import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/cattoire/data/git/instana-humio-hybrid-systemZ/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">1-1: Explore the Infrasture View</AnchorLink>
  <AnchorLink mdxType="AnchorLink">1-2: Exploring Context Information</AnchorLink>
  <AnchorLink mdxType="AnchorLink">1-3: Exploring the Application</AnchorLink>
  <AnchorLink mdxType="AnchorLink">1-4: Working with Events and Incidents</AnchorLink>
  <AnchorLink mdxType="AnchorLink">1-5: Summary</AnchorLink>
    </AnchorLinks>
    <hr></hr>
    <p>{`In this portion of the lab, you will explore some key Instana capabilities including monitoring of kubernetes, monitoring of applications, and monitoring of infrastructure.`}</p>
    <h2>{`1-1: Explore the Infrastructure View`}</h2>
    <p>{`Begin by logging into the Soleil lab environment. You should see a picture of a desktop system. Click on the system to login.
After logging in, launch the Chrome browser. The browser will open with 3 tabs`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "69.44444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAABYlAAAWJQFJUiTwAAAC+UlEQVQ4y52T22vbZRjHf/Wwm14Ug7g2B5qmrWlT8WJ4M+/8R7wT9EKmUmeTFssUJoOhFzJRdmjSJqngrMOBs02Tpm5uTrZF2rF2PeR3Puectpt48ZH8Kswrwb3w4ft9br7v87y8jzC/vE06r5HOq6RyCqklmVROZi6vc+HqBvHPzjN15qLHqc9n+XD6C95PnGH6bJLxT87xwfSXnPz0HF999zvZoonwzaJEpqCRyaus79YQjSZbcpUHcpU7D03uiw0eKG3WxTpr5Rrr5RpruxXuS002tX02lDabaosb6xazOQUhmRNJFzSyBZWNsoZjaWiaiqoqiJKIWN5Flsqoquxh6JqHpinomoIsSxiaxEPRIpVTETqdZQo6qcUyr73+BqFggFhsjEhkEL/fTyAQ8PD7A/g99f/DoQ8EQxx96UXeHZ/m8q0aQuftMis6yZ93CYajCILwVLz51gkWbjcQZpdEsis6M9d2iL5yjL7eo/T1+QmFQvT29jIwMEBPT49Xd3wwGKS/v59wOIzP56Or6xkv8O0TcRZ+ayB8/f0a2aLBpWvbvHrsOJGBMLGxMQYHB4lGo0QiEUZGRhgeHmZoaMjT0dFRYrGYd8HzR454ge+8lzgMnLtyi/miSfKnHQL9L/Pcs1284PPR3d39v0f+4XYTIX31JtkVg/O5MqdOn2UyEWdqaorJyUni8TgTExP/STyR4KOT46S+/ZH5VRvhyuUbpFcMPl4o4bT3edqjVw6YWZQR5pY10gWV9KLIVln3/pwoShimgWmaWJaF4zjYjo1t215dcSs0Gg3q9Tq1Wp29VoMt2SW5pCBkOmF5lfmizo5soesaqqohywqSLGMYJo7j4rgurlvxtFKt0mq1abXbNFttHh3ssa1U/x14uCmq4VJ1DGzLwLEMXNvEsXRc26Bec2nWq57uter8+Xjf4/GjffjrAMmoMbMkP+mws8+rJY1f/1C4XpK5XpKecE/il3uHfvWuyM01lTubDnc3HU9LWw7FksnsssrfUBYQNXKaTwUAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "browsertab",
        "title": "browsertab",
        "src": "/instana-humio-hybrid-systemZ/static/b3ad67ec115cc4d178a2408a257b78a0/3cbba/browsertab.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/b3ad67ec115cc4d178a2408a257b78a0/7fc1e/browsertab.png 288w", "/instana-humio-hybrid-systemZ/static/b3ad67ec115cc4d178a2408a257b78a0/a5df1/browsertab.png 576w", "/instana-humio-hybrid-systemZ/static/b3ad67ec115cc4d178a2408a257b78a0/3cbba/browsertab.png 1152w", "/instana-humio-hybrid-systemZ/static/b3ad67ec115cc4d178a2408a257b78a0/0b124/browsertab.png 1728w", "/instana-humio-hybrid-systemZ/static/b3ad67ec115cc4d178a2408a257b78a0/4ea69/browsertab.png 2304w", "/instana-humio-hybrid-systemZ/static/b3ad67ec115cc4d178a2408a257b78a0/b3e5a/browsertab.png 2678w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <ul>
      <li parentName="ul">{`The first tab is the lab guide.`}</li>
      <li parentName="ul">{`The 2nd tab is the Instana user interface`}</li>
      <li parentName="ul">{`The 3rd tab is a file that contains the username and password that you will use to login to Instana`}</li>
    </ul>
    <p>{`Use the username and password from the 3rd tab to login to the Instana user interface.
You should now be looking at the home panel for Instana. The focus of these lab exercises will be on the monitoring information in the ‘Applications’ portion of the display.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "46.18055555555556%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAAsTAAALEwEAmpwYAAABLElEQVQoz42S20rEMBCG+4h6ISjoncLiLsr6oPsk3W1znMnk8Muk9cIixcLPBEq+fJnJ8Hz4RLlckIlQWkMpBaXW3dRNjHUYbzOu04zh6XiG9x6zMfA+LMBS17pNBeUMlwSOEygJSCsnjJOBi4Th8fiFyATr/GJQ9qNGUQqMJ1gWTNaDiHGdbT9geDmdEZgWu1qRS9mNmrIU2EDwnDuQf2wV+HD4gH5J5E+bJBmBZYGtN9C15AzRKrmvFRY5Ybh7fQdRhA/hXwPJpSIoIC8gBfJq14H3b6f+w/nQjfZ6ZyjDRIZjgYsMG1Pfp7f7BWRJffS6UXJB3mbt3RgEo42YQsLkIm6eYLSHW8PewySora1vqy3Rd1krpFS01uBTgWfpU45JEFLudnqgwhT4DbLKsdZ6kUEaAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana",
        "title": "Instana",
        "src": "/instana-humio-hybrid-systemZ/static/7d51529bfec5170b1ba916f4285a583c/3cbba/Instana.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/7d51529bfec5170b1ba916f4285a583c/7fc1e/Instana.png 288w", "/instana-humio-hybrid-systemZ/static/7d51529bfec5170b1ba916f4285a583c/a5df1/Instana.png 576w", "/instana-humio-hybrid-systemZ/static/7d51529bfec5170b1ba916f4285a583c/3cbba/Instana.png 1152w", "/instana-humio-hybrid-systemZ/static/7d51529bfec5170b1ba916f4285a583c/0b124/Instana.png 1728w", "/instana-humio-hybrid-systemZ/static/7d51529bfec5170b1ba916f4285a583c/91583/Instana.png 1886w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Note the middle portion of the home panel lists applications currently being monitored by Instana.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "24.305555555555557%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAFCAYAAABFA8wzAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAwklEQVQY032QS27CQBAFfa2EQ4SsIOePwgJsbOPP9PRnKhnDEtJSrZ766amat48D0+1GPwys84ycTuSuo14p5SWUQlSikN0ZVVnUaHafXxSgu/ZIVgJwwNxxj6fULMIZkvHdr6gIozj9ONHs9ke8xFaYJOPumNn2ZPYcNcPNGMX4GVZEhPNidON8L7TinC8tKQke9wWviLqy6gD6x8IsQrsa3TDRvO+Pmy9VJSL+9VbzRZ10acltixaYsxHuJAvyn8NfcsR93C5imxUAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana apps",
        "title": "Instana apps",
        "src": "/instana-humio-hybrid-systemZ/static/d248a1c3429d31d2344346251e89cdb0/3cbba/Instana-apps.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/d248a1c3429d31d2344346251e89cdb0/7fc1e/Instana-apps.png 288w", "/instana-humio-hybrid-systemZ/static/d248a1c3429d31d2344346251e89cdb0/a5df1/Instana-apps.png 576w", "/instana-humio-hybrid-systemZ/static/d248a1c3429d31d2344346251e89cdb0/3cbba/Instana-apps.png 1152w", "/instana-humio-hybrid-systemZ/static/d248a1c3429d31d2344346251e89cdb0/77c84/Instana-apps.png 1410w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`In this environment a number of Instana agents have already been setup for you. So you will immediately be able to start exploring.
The first place we will look at is the Infrstructure View. Here you will discover a map of all the infrastructure that was discovered by the installed agents. Navigate to this view by `}<strong parentName="p">{`Clicking on the Infrastructure Item`}</strong>{` in the left side menu.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "76.04166666666667%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAABYlAAAWJQFJUiTwAAACQUlEQVQ4y5VSTWtTQRQdrRGkpIpUjZvGpCYkjSZpg6a0SZtKErpQKAh16x8QXKt/wYUboX9HEBHETUzSmNjm883Xa8SFhXzQIzNvEmKt0Dw43Hn3Xs7cM+eSFrXR6AjU6pZGU/4El10w2YXs/kKHHaFQrqK4X8V+9UDHUqWm44ePn/D5y1dUaocoVw80SLFSRqX0DaViAeViAbXad/w+Pkav13PQV+ijPxhgMBjoqM/DIdR3cgJTG+o6Sbx8i7VXe0i/3sPii3fIvXkPW3DY9hGkbcMeQUpIKXUcnaUQ45w0IDcyTzG/tYubj3ZxOfkE4Z3nEJzrohBiapDbsYe4FozCfTcC4vEisJYBYxyMMVDKQNl0INejq3CHE5jxRUDmvfCvZ1GvN1BvNGBROtV06gmIL5mB98EGPNEkZv33EM8+Bp0gkuchkgJMCHSYAIltbiO+uY37qRz8K+vY2nmmR+fckc1UPA1mYP5Vb5syVFsUxB1axmwwjgsLIS15MZXVt3IF0zyJ09PpvBCauEU5yOLqMuZCMVy6swTi8SO4kdcSznJZ5RgXsCiHZaac7NNvqKa7EjCEt3wIpPOO3JHkkTwj36IMbYtqdCg1PWzcQ66GE5gLrxhCPwLpnC6M5PzPTUeFgJB/m0NcvghcvqUxYTCdP9diq3ezlHzL2Qh17lAGcnEhBAWXkawIuZhw8wyX1RY0LYZam6HebGlFdYvjsNUGmfGGoTCWnMo5a2Oc+8dpk1eEP9oMjWbLuYAKNNsd/AEsls0uOcQWaAAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "select infra",
        "title": "select infra",
        "src": "/instana-humio-hybrid-systemZ/static/93c9517589864e574c83714082988d52/3cbba/select-infra.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/93c9517589864e574c83714082988d52/7fc1e/select-infra.png 288w", "/instana-humio-hybrid-systemZ/static/93c9517589864e574c83714082988d52/a5df1/select-infra.png 576w", "/instana-humio-hybrid-systemZ/static/93c9517589864e574c83714082988d52/3cbba/select-infra.png 1152w", "/instana-humio-hybrid-systemZ/static/93c9517589864e574c83714082988d52/0b124/select-infra.png 1728w", "/instana-humio-hybrid-systemZ/static/93c9517589864e574c83714082988d52/a7ba4/select-infra.png 2236w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`You should now see a map as in the image below, showing the discovered infrastructure. Notice that it is organized in zones which is a mechanism to group the data from a number of agents together.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "47.56944444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAABYlAAAWJQFJUiTwAAABn0lEQVQoz42RXU8TQRSG98+gd1ruKkXZjxY/IoRA2912t/s5W2kRtWCAC5JmTQgkhgCxxtpYGzUxXhr/4GNmSpsqEL14cubMvPOec2a0d/0hg9E3ZJT0Pg7p9f/NWPuZD5++qPvvByP6w69o84USeeMJMt7KFZi7u8Bc7v+Q+tvzi9zJm4rcPQvNqAYsOxFFO8Qo+xjlxg1cf6ZLNjyMio9VDdCW7JCiK7DqiYqzlLyUopdiuQlGLaboiSsaxeW+5Qo03Q6VmVmLMWuJWk/y+5WGiiWvxVr6At2OMJ0YS2n/xLpkxlAaRSxVAwwn4qHfZvfojEI5IHsbkl2c0jzMMOsBVl1MC/+NMpSjLax7ZOfnHJwckV+rE+48Y/RjxM7BG/YyB3frFevbz1ltCUwnudlQdiPnl52l+12+//xFdjHg8LjB66xJ2j1lWbzksddGt2MMO75iMvmDqeEkWdzwWInbZGc93M1NnjY7PBIdSg3BrG4Wuf+g4iMnleupoXxYWUnmRtVn1R+LTSccP/o1ZroTsZJsIfa7lFsdnO09fgPbe6BXWvaqcwAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Infrastructure map",
        "title": "Infrastructure map",
        "src": "/instana-humio-hybrid-systemZ/static/06d6b1bc5352e9d5daa07cdff60d7269/3cbba/Infrastructure-map.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/06d6b1bc5352e9d5daa07cdff60d7269/7fc1e/Infrastructure-map.png 288w", "/instana-humio-hybrid-systemZ/static/06d6b1bc5352e9d5daa07cdff60d7269/a5df1/Infrastructure-map.png 576w", "/instana-humio-hybrid-systemZ/static/06d6b1bc5352e9d5daa07cdff60d7269/3cbba/Infrastructure-map.png 1152w", "/instana-humio-hybrid-systemZ/static/06d6b1bc5352e9d5daa07cdff60d7269/0b124/Infrastructure-map.png 1728w", "/instana-humio-hybrid-systemZ/static/06d6b1bc5352e9d5daa07cdff60d7269/4ea69/Infrastructure-map.png 2304w", "/instana-humio-hybrid-systemZ/static/06d6b1bc5352e9d5daa07cdff60d7269/95968/Infrastructure-map.png 3526w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`You can filter this map by entering queries in the top bar. For example `}<strong parentName="p">{`enter “Raleigh”`}</strong>{` in the search bar to filter out one zone.
You get a view containing only the infrastructure which sits in the defined Raleigh Datacenter zone.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAABYlAAAWJQFJUiTwAAABVElEQVQoz52Ry0rDQBSGZyMuBFHBhW4UF4JVQykVbNJaMkkv2qptSdMm6SWTpFqlFM2mKxf6cm4E3bjwaX6ZBnujlNTFx8A5Zz7+M0M2j+OQMje4qpjIlw2k82WIShGSev0vyLZwDjFXglzQQItV0IKGZK6EqJSBkFAhiDPMq01AdmISkloTquFAqTPQmg1ZXwyfGTKnR7aEBFJcaHmgpgslJOna/DrZFbNBQi7kKSfhQ7M1w4VqOjB798hYbnDHHPfJRiQ+LVyQSrVcSJqLxwHD57uLRt/GhR7URwn3Ts8ga00oIYQ8UaLiYPDq4OfLg+23kap608K1w+j4DUMkTOp38F9cfH/YaPRbSFV5j42F60ex0EIONTsosA4cn+G2+wT9+Q2XrAdaD6Rk9eBkKSH/AGp4w1WzrQcUOz6yre7oLlnZjywpDKSqxcUMcq09PP9W/gUQWKxI6BIcaAAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Raleigh zone",
        "title": "Raleigh zone",
        "src": "/instana-humio-hybrid-systemZ/static/6be0d978eece85d4dc62d8730387a9c3/3cbba/Raleigh-zone.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/6be0d978eece85d4dc62d8730387a9c3/7fc1e/Raleigh-zone.png 288w", "/instana-humio-hybrid-systemZ/static/6be0d978eece85d4dc62d8730387a9c3/a5df1/Raleigh-zone.png 576w", "/instana-humio-hybrid-systemZ/static/6be0d978eece85d4dc62d8730387a9c3/3cbba/Raleigh-zone.png 1152w", "/instana-humio-hybrid-systemZ/static/6be0d978eece85d4dc62d8730387a9c3/0b124/Raleigh-zone.png 1728w", "/instana-humio-hybrid-systemZ/static/6be0d978eece85d4dc62d8730387a9c3/4ea69/Raleigh-zone.png 2304w", "/instana-humio-hybrid-systemZ/static/6be0d978eece85d4dc62d8730387a9c3/71706/Raleigh-zone.png 2442w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p><strong parentName="p">{`Click on the Linux server host`}</strong>{` in the picture, be sure to click on the outer containing box, not on one of the discovered services. You now see some details of the server.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "64.93055555555556%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAABYlAAAWJQFJUiTwAAACeklEQVQ4y5XRz0sUcRjH8TmFh44GRXUIQSGwtEBzU9fdHdfc1vVX+2u2RXdmd7VctaioS+ZB6RZFQeCl+gOCooTQMvIcXcOi1HV/ubM/9RB0eceMum2SUIcPMzzfhxfP9/kKlbUNNIlddPZKWLvdtHb0YBDttFi7abE6aG7/vwiVJxo5Y7FjtvVjsvVj1ECLnbomkTqDSL1h61ue+j3qWoSjDUaaeyVskkKXJNPpDSA6BzD2SJy1uzDsilZrOu+m0ebR/3f3CPtr6hm5PcX3WJK5j0t8WlpBzWVZTazTd+kqJq9Muz+MeDFE+8UQZimEIxgicC2MyRdG9G/Vxe0IB063MTx5l2fJJPe/LBP/fA9ys/z4Cf1DY7S6BrBICmavjCjJNF8I8uChg/lZEz7Zg9U5iFlSsHhlvUeoqDnFyMQ08UKRtVyetBolX0gTTaToDkYwugd1UIsOOoPMzHTpYFjpw+ySsfiUUo9wsOYk4xNTZAtFUukMsfUsamGT5egaDmWEthIoI/oUWlxhnj5xsDhvov+yn1Z3UD8rgRXHjhOZmGIttU58XSWRVskWN1iOxvQJd0DtOtqujJ5hbk46efS4A4ei0DE4iugL6uc6uK+qVn8U7YoJNYOaL5Db2OTbahSHEimbcAu1+IKYpCHaPEHs4Rt4rk9zLhDB5AlsgcKRah1cTaRIZXKkc3kyhSLReJKe0NgfO/z9OEppDTuTla4sHKrSwa8rUT3LsQRJNUsslaZvaByja7AMKI/8l9o2OHpnmngqTVLNkExnyBY2yOQL2+DAHqCyB3i4Gv+VWzx/85aX8+959e4DrxcWeTG3QJesvXLgnzEN/AUBr1D7zeIOQAAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Raleigh server",
        "title": "Raleigh server",
        "src": "/instana-humio-hybrid-systemZ/static/e6a78a64da047af961d2c71c24daa0a7/3cbba/Raleigh-server.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/e6a78a64da047af961d2c71c24daa0a7/7fc1e/Raleigh-server.png 288w", "/instana-humio-hybrid-systemZ/static/e6a78a64da047af961d2c71c24daa0a7/a5df1/Raleigh-server.png 576w", "/instana-humio-hybrid-systemZ/static/e6a78a64da047af961d2c71c24daa0a7/3cbba/Raleigh-server.png 1152w", "/instana-humio-hybrid-systemZ/static/e6a78a64da047af961d2c71c24daa0a7/0b124/Raleigh-server.png 1728w", "/instana-humio-hybrid-systemZ/static/e6a78a64da047af961d2c71c24daa0a7/4ea69/Raleigh-server.png 2304w", "/instana-humio-hybrid-systemZ/static/e6a78a64da047af961d2c71c24daa0a7/8118b/Raleigh-server.png 2464w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`To get more information on the server `}<strong parentName="p">{`click on the Open Dashboard`}</strong>{` button. This gives you a dashboard with the various aspects which the agent discovered about this server`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "45.138888888888886%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAABYlAAAWJQFJUiTwAAABkElEQVQozzVS2Y7bMBDz//9X+9iHbbF1sTGS1OlmHV+SdY1OFhrbBggNCA3J0bgRww9cune0XY+3jx7t9RPGOvgQQT6CQuQ6xMT1iZNzRNiUhnXEaMbHN1zvLd7+3NB2N/y+3LBKhRCrYOBG4whKG6592DlLBGXsIRyPAAFNPwg8pxWzkBDaQCoFbSxiyogxIabEja9pgTsMfExsMk4zi9SkZ4Cm+9vjtax4LYIxiQ2rFAhEPFouGZY8lBTw1gAoqF8IAWJTSDGilMKo5s3l3uNrWli0nlJbxJz3sULcE1LA+0z4NQf8nDy+Pwm9JKAUpFwQ6jQ5I1TBtrvi9vjEYxhZcBIS0hKkI0zaYtGWn+K1WczGYzGEQREWZbEZC+UCNuehKUDXpXxc7/g3jHiOM2NeBaTcIKREjBEpJV5EHS2nxCg58ciVr3cqiPy+5a9FYpUbtHXsUH8ZItov1uZSkHNGSpnfLh3cyZeDq3VdYjMIjWUVMORhanRjWTDnAvKeRf2RJuW8c7zVxHU1Os/K/QdeqLdc/3TlYwAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Raleigh server detail",
        "title": "Raleigh server detail",
        "src": "/instana-humio-hybrid-systemZ/static/50c513d37d1a52b54e893ed614194915/3cbba/Raleigh-server-detail.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/50c513d37d1a52b54e893ed614194915/7fc1e/Raleigh-server-detail.png 288w", "/instana-humio-hybrid-systemZ/static/50c513d37d1a52b54e893ed614194915/a5df1/Raleigh-server-detail.png 576w", "/instana-humio-hybrid-systemZ/static/50c513d37d1a52b54e893ed614194915/3cbba/Raleigh-server-detail.png 1152w", "/instana-humio-hybrid-systemZ/static/50c513d37d1a52b54e893ed614194915/0b124/Raleigh-server-detail.png 1728w", "/instana-humio-hybrid-systemZ/static/50c513d37d1a52b54e893ed614194915/4ea69/Raleigh-server-detail.png 2304w", "/instana-humio-hybrid-systemZ/static/50c513d37d1a52b54e893ed614194915/d9e93/Raleigh-server-detail.png 3300w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`With the time selector on the right you can select which time frame of data to look at or use the option to see live data. When `}<strong parentName="p">{`clicking on Live`}</strong>{` you start to see metrics in real time being refreshed at 1 sec resolution`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "800px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "30.555555555555554%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAGCAYAAADDl76dAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAvElEQVQY042PyQ7CMBBD+//fWBAX6CaVoNKQ2WKU6aKIEwcrmYnzZDfEgn+U/vQ1aTe7iH3Jovgk8lnNfBa1Dbx7jncu/n1f1BSzi7dzjRHP8IKIQlXRDyNCCBjHCYkIOWcQM8wMSRkLR0RJYN0T1nELZFneGMbpBN4fHbquR9tecbneMIcXiBimho8QAq3o44yVk4fyhEdNh6rBcj6rZcABZT5qiqqnLAAVg2n2uyc8KtfQ817ta/166z9fW2PVLLFS03IAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "time selector",
        "title": "time selector",
        "src": "/instana-humio-hybrid-systemZ/static/9b534e02b1e38ca00b8b1e70abe41bba/acfc1/time-selector.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/9b534e02b1e38ca00b8b1e70abe41bba/7fc1e/time-selector.png 288w", "/instana-humio-hybrid-systemZ/static/9b534e02b1e38ca00b8b1e70abe41bba/a5df1/time-selector.png 576w", "/instana-humio-hybrid-systemZ/static/9b534e02b1e38ca00b8b1e70abe41bba/acfc1/time-selector.png 800w"],
        "sizes": "(max-width: 800px) 100vw, 800px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`With the drop down you can select historical data to see how things have evolved over time.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "68.75%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAABYlAAAWJQFJUiTwAAACBElEQVQ4y51Ty44UMQzs/+UT+AJ+iwMCJLjsssNohoUDq13m0ZnO03GSLmQniwbEAdGS5Y7bsctV7ilzwZ9GmUF/iV+b9wHLty9Ytnewuw3c1z3csmCSj1wqWDwXlNrQ2opaG8pVnK+Khcw43+/x/c1r7D/d4f7zFj8+vMNxe4dJCqTMSJJcG4x1eHg64HA2cDGBSkFiRi5FGxTxteJ0nnHcbWE2NzCbW9j7HZy1mJwPOFmHR+dxiAlPPuBhsf0cIk5EOCaCzdxRDxNaclvRgF8WE2HyMSGEiOADYojAuqLI6FzQakWmDM6syOSCFhpWawVJLJFSkihjipThQkBKpETLOD5EOO+RmbWZnCln+JFHlDXe1hUxdUByT3KmxQdY3xPlg3QVH2NSVLO5aEwQGXNRL7nH01kbCYjzbBR5kJEFpnUdjQRV8TKULb3rr3fKWpB1tfLVmmW9IzV0ZBsS8hipNqH3/55aCiYlmkjH6kh6J+FE/UBZB0etNY0/nwMzHlOC4/4z6Mg+5b5fY8/6habjSYFEhHVd1YsQMrpM0rj8htATY7JDQSHaDZWDClJVGD8UFPKfn3X4t8bgxc0NXm42eLXf4eAjJlEmpa4oj1Ged7AMcTodrDFB2pTnFUcivJ9nfDQGt8uiObo2ZrH/ZOfLgnm8zxcLax2yDyBZO+dxsQ4/AdzPPnnyUDsPAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "history selector",
        "title": "history selector",
        "src": "/instana-humio-hybrid-systemZ/static/51744fcccad7d840fab94d829de0b1b5/3cbba/history-selector.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/51744fcccad7d840fab94d829de0b1b5/7fc1e/history-selector.png 288w", "/instana-humio-hybrid-systemZ/static/51744fcccad7d840fab94d829de0b1b5/a5df1/history-selector.png 576w", "/instana-humio-hybrid-systemZ/static/51744fcccad7d840fab94d829de0b1b5/3cbba/history-selector.png 1152w", "/instana-humio-hybrid-systemZ/static/51744fcccad7d840fab94d829de0b1b5/9c603/history-selector.png 1638w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`You can now also drill down in the objects which were discovered by the agent on this machine. `}<strong parentName="p">{`Click on one of the ACE Integration servers`}</strong>{` which you see in the entities list on the machine overview. Best one to look at ist the EG2 instance as it is the most used one in this sample setup.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1016px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "102.43055555555556%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAABYlAAAWJQFJUiTwAAADmElEQVQ4y3WU224bVRSG5236ctzxBNxwwwWiIAGVqlJRFYGKqogi4KJSRVFaJ27qNHZ8jMeezPk8nvPY4w/tbccpBbb0ae/xWL/Wv9Y/W3HCBjNoGc5jxqqLaZlYtovjenieTxDFiGUmDUMrZ2TnLMOGm7UF6vWGZr2hbtYolfecbHEPnPsU7nPOBion50Nev73k+M2ATm8o95O3l5z2LumeDznpDTh+0+fF6x4L3abdbqWYEFWuTz9m8PQO8cs7aJ2PuPvwV+4+eCL59KtHfPbtD3x+/wn3Hv/C3Qc/8+V3T/n60RHfPDriky8e8mfnXFZaVs2uQstxEBiW2D1p8UP8MMILIrnLcxixynKauqGuaqqqOqC8HYzoXgwZz5csdIuFYbHQTZaGjeUF2H74nxRVRd7UZHVF0dTyXK3XKKOrOeP5As2wUHUD9dqQgppp4wQRTvBvMfF7WpRoUcwyjNCjmAtNZ+kFKOeXIybqUopcLXW5zxYaU1Vjfm1guv5eKHiPkLKqYbs9TDuJE9rNBqU/nnIxnqHqJrrtSq4th2vLRXe8g21rX518DiKyoiCKE7K8YLsXFtNWBpMZ74YT2TsviqUdN7yxGkiBDxHCUZpJ26usIElz4jQnyXKUs/4lZ/3dUKbqkulCk5bFUITdDzFcX4pmRUmzXu8RoW5kGxTHD3GDUEbGsF3MPbbr44p38n10i4hNlLBKM1RVZTQeM53OmM/nXF1dobhRjBlEJCKYQLXdUQraPeuWsm4kaV6QZAVFVbNerw/5E5VuxFD8yYio+4qkd0r6rnsgE5x3yYcXpL7HSvRLiuVEq0wKiiXERPiFmFhK7+gZdr+H9qaD1n2NdnKMfnbKsneGM7ok6bwkefYTfpoTxAmiRU4YyX41dU1ZlmRZRtu2ctrKcjJF7xxjnnYwT16hv+thdE9Ijh4Tv/idYDrCD0K8OJG9E0kQiArruqYoCtJ0J7hpW5SxGTCwIsZ2yCiqmP3xG4sfv8dfqLirDDfNEX0Ww3DD+IAQzEUb0owwiqnq/eWgGi5Xus3CsFm6Efqrv7ju93HzCscLcPxAZnL3Gd5S7isUlldpKqtr2y3KTHeYaBbDpcVUs5g4EVMrYKZZ/xtsS14ON5ZLVquUzWZvWVRheKFEdwMMx0d3fEwvPFwO/2RX4fuW/SC6tXzmlnh+gGFaxKuUJE3ln8N41yeRPbHfnPOykvERz+ITbqXVW/4GlcDN956pBZAAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ace interface select",
        "title": "ace interface select",
        "src": "/instana-humio-hybrid-systemZ/static/f9277478ea0a11d5da8705cd3e884689/9d5f5/ace-interface-select.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/f9277478ea0a11d5da8705cd3e884689/7fc1e/ace-interface-select.png 288w", "/instana-humio-hybrid-systemZ/static/f9277478ea0a11d5da8705cd3e884689/a5df1/ace-interface-select.png 576w", "/instana-humio-hybrid-systemZ/static/f9277478ea0a11d5da8705cd3e884689/9d5f5/ace-interface-select.png 1016w"],
        "sizes": "(max-width: 1016px) 100vw, 1016px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`You now get some details on this object running on the machine. You see for example that it is a JVM, you can analyze the memory consumption and if you scroll down the message flows it is running.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "48.958333333333336%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAABYlAAAWJQFJUiTwAAABWUlEQVQoz22SW2/bMAyF/f//117y1A1YUPShKzqkKOr4phsvknwKKkljr3v4cETaPCQFdZwEzIpEjESCuq7IpUI0Q3OB6I1bnPdnUcRETSVndMf+BYffR/w4/MLh4YjDz0f049JMWRSseYdsTO07sWBxASkRSBXd0+kVz6c3vJzeG3/+vqEfRojqxfAfZufhQkRibv808r1B93p6x8c44TzN6KelFcyLa51Lqcil7LBJWAQ5l2+orTw5jyVELD5i9hGj8+inAaNbEIRAQkicEIURmZGEoTUjrxVaC3QtTfNVO7J72GHdtSHCe5jBTFARqP6fLrFgSwgJs60+zgguIPh4x0X4Ta6dXWh6Y2doE04+4DwMOI8DfAzgNh2BbDqxCQXEBFF7YhW1Xlkriq28NTONdCmyAmYGEbU1TanFt5w1km9c7nBj2J4HK4gUwnmH5XmTt/grb0qKT9XcCHOcuSx/AAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ace details",
        "title": "ace details",
        "src": "/instana-humio-hybrid-systemZ/static/5091eebc1e83a1873f88601557dc1941/3cbba/ace-details.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/5091eebc1e83a1873f88601557dc1941/7fc1e/ace-details.png 288w", "/instana-humio-hybrid-systemZ/static/5091eebc1e83a1873f88601557dc1941/a5df1/ace-details.png 576w", "/instana-humio-hybrid-systemZ/static/5091eebc1e83a1873f88601557dc1941/3cbba/ace-details.png 1152w", "/instana-humio-hybrid-systemZ/static/5091eebc1e83a1873f88601557dc1941/0b124/ace-details.png 1728w", "/instana-humio-hybrid-systemZ/static/5091eebc1e83a1873f88601557dc1941/4ea69/ace-details.png 2304w", "/instana-humio-hybrid-systemZ/static/5091eebc1e83a1873f88601557dc1941/d9e93/ace-details.png 3300w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`You can also see how this messaging object fits into a flow. `}<strong parentName="p">{`Click on the flow tab`}</strong></p>
    <img {...{
      "src": "images/flow-tab.png",
      "alt": null
    }}></img>
    <p>{`You now see how this messagig object is being used.`}</p>
    <img {...{
      "src": "images/flow-details.png",
      "alt": null
    }}></img>
    <p>{`Another way to look at infrastructure is to use the comparison tables. To do so click on the infrastructure icon in the left tool.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "132px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "903.0303030303029%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,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')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Infra click",
        "title": "Infra click",
        "src": "/instana-humio-hybrid-systemZ/static/eaed387375c10421d9117316332b78ad/c1cc7/Infra-click.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/eaed387375c10421d9117316332b78ad/c1cc7/Infra-click.png 132w"],
        "sizes": "(max-width: 132px) 100vw, 132px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Now click on the Comparison Table tab at the top left of the screen `}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "482px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "34.375%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAYAAAAIy204AAAACXBIWXMAABYlAAAWJQFJUiTwAAABYklEQVQoz42PS2/aQBSF/WOaqrsiRMDB2HiM35hxbKAQOy1pzMuKhL1q1F3/+VeNSSp1U3Xx6WjOHN17rvZhYGJ6krtZwvg/Md7Q3QVDV/55qz/t49BGREvM4B7rn2SdmkHGOMwxgpzAX1DMPPJZgBnmXUa7ubWw/JSxu2DiSQx38RfKe8fwJJabkDgBpS14sB1CJ+zajUTMnTNHUyergbqYM7KjTtUgVV93lBd3/tCOMaYBr3qf3BJMpj63TsLIvZaomx8sywrtZmAxcSWr3ZFj84pcf0UXEYaXUn6vqY4Nh3NLdbqwf2kpvh0oDxfan79YF8/dMtOXPNct99snNdDE8iQiyomyEjdZMXauLUVW4G12xGWFv9nhPzwhlo84y5KwrHDS7TWrTp6G6CJG+2S4zLICM1ljzldYyRdsucFOtwz2L/Tqlt7pQu/UdPTPLf1zw+e6ZfS4RyTrLivSbae/AbqCBP9o3nD4AAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "comparison click",
        "title": "comparison click",
        "src": "/instana-humio-hybrid-systemZ/static/18eef9abbe3f995bff981d851ba7c0bd/20d66/comparison-click.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/18eef9abbe3f995bff981d851ba7c0bd/7fc1e/comparison-click.png 288w", "/instana-humio-hybrid-systemZ/static/18eef9abbe3f995bff981d851ba7c0bd/20d66/comparison-click.png 482w"],
        "sizes": "(max-width: 482px) 100vw, 482px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`This shows you the comparison table. By default the subject of the table is the Hosts and the metric shown is the CPU usage`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "23.61111111111111%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAFCAYAAABFA8wzAAAACXBIWXMAABYlAAAWJQFJUiTwAAABNElEQVQY003My0oCARTG8XkjXZRg6ZA3tLwUBQkRRQRBtOuNWrWJMhWkpvEaboTeQUrNGWecizpegn84RrX4wTkf3zlCZOeAQCyDP5x0+ba2WRfjv7s/lPyb/wsl2QinCMR2iaUP3R+b0TTC8dU1+ycXeINxvGKcSCZLKnuKJ5hwecUEnqVg/I+4ypd80Qxr4RR7R+dkzy4RpGaLB6nGzX2R23yJ3JNMqfpKXq6RkyrclSRyzxUK5TrFcoNipUFBrpOTquTlVfb4UkNutqi23hBGzgzNduibDpYzx1l8oZk24+mcoTWip6iousFktmAyXzCezRk5UwamjT2Zup3uwECzRliOg9DXDTrqkHdFRxmaqEOTnqq5c1cZ0O70+Oirbq78WN4ouomiG2633VP41AxUXeUbmyof05AfruMAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "comparison table",
        "title": "comparison table",
        "src": "/instana-humio-hybrid-systemZ/static/deed84246a216b966f57c3befc0e7113/3cbba/comparison-table.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/deed84246a216b966f57c3befc0e7113/7fc1e/comparison-table.png 288w", "/instana-humio-hybrid-systemZ/static/deed84246a216b966f57c3befc0e7113/a5df1/comparison-table.png 576w", "/instana-humio-hybrid-systemZ/static/deed84246a216b966f57c3befc0e7113/3cbba/comparison-table.png 1152w", "/instana-humio-hybrid-systemZ/static/deed84246a216b966f57c3befc0e7113/0b124/comparison-table.png 1728w", "/instana-humio-hybrid-systemZ/static/deed84246a216b966f57c3befc0e7113/4ea69/comparison-table.png 2304w", "/instana-humio-hybrid-systemZ/static/deed84246a216b966f57c3befc0e7113/1a8aa/comparison-table.png 3322w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`You can select other topics in the Table content drop down.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "480px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "132.63888888888889%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,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')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "table content dropdown",
        "title": "table content dropdown",
        "src": "/instana-humio-hybrid-systemZ/static/5963c5ae8e4e2ce3d80e3cc14131c1a4/c9161/table-content-dropdown.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/5963c5ae8e4e2ce3d80e3cc14131c1a4/7fc1e/table-content-dropdown.png 288w", "/instana-humio-hybrid-systemZ/static/5963c5ae8e4e2ce3d80e3cc14131c1a4/c9161/table-content-dropdown.png 480w"],
        "sizes": "(max-width: 480px) 100vw, 480px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p><strong parentName="p">{`Select “CRI-O Containers”`}</strong>{` This will show you a similar table but now on the CPU usage of the different containers in our environment.`}</p>
    <h2><span parentName="h2" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "47.22222222222222%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAABYlAAAWJQFJUiTwAAABu0lEQVQoz3WQy2sUQRCH5//w4F0PwgaUNYqQTUIeo6toSFZRYpQ9xIAnRRANiAcv4iH/klfxkMRgdnb20dMzPY9+zY7x+NOuXaOJevio6mr666ryztSmcXW+iVn/Duozy5i6Mj9hDrXpuT/O/6fe8HG54aM+48M7e/Eamg/a2Hr5Bisbm1hcewj/3mO02k/x5PlrLLU2sLC6TvXF1fXjvHm/jeW7j7D57BW2Xmxj+90HvH2/A2/qxho+ft7Dp4MAe50QX3oMu+GY/V6EgCXoRicJWIz9TojDQYSQCzoHQ46AJ/Au3WyhG+cQukL57TsyU2GYGbB8DC8sZFnBVkcw1RFFXVZgSYpcW6iyophJAzmq4NWWbuNgEGOYarrghUE3LhAmElGukWmLwpTITUnR4Wo9xpHkkt4khaI8NRbehYVbOGQCUWEgbYlYWvRThcGE2P1sRydw8gFPIKSmD1KpIQqFzFp452ev4ysTYJmhSyfsCYm+UBRdl05anBL2eXwsFMUvYQnvXMMfC/PTQkkdskzTGv4SRjFJchKq3x06YSdKEU2EiRtZKMKJVDki/jWyG5XnCjyTlGc/d/gDvh9K9xlG5NkAAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "crio containers",
          "title": "crio containers",
          "src": "/instana-humio-hybrid-systemZ/static/a9386e2666e3b55ac995b1ac82ef56d6/3cbba/crio-containers.png",
          "srcSet": ["/instana-humio-hybrid-systemZ/static/a9386e2666e3b55ac995b1ac82ef56d6/7fc1e/crio-containers.png 288w", "/instana-humio-hybrid-systemZ/static/a9386e2666e3b55ac995b1ac82ef56d6/a5df1/crio-containers.png 576w", "/instana-humio-hybrid-systemZ/static/a9386e2666e3b55ac995b1ac82ef56d6/3cbba/crio-containers.png 1152w", "/instana-humio-hybrid-systemZ/static/a9386e2666e3b55ac995b1ac82ef56d6/0b124/crio-containers.png 1728w", "/instana-humio-hybrid-systemZ/static/a9386e2666e3b55ac995b1ac82ef56d6/4ea69/crio-containers.png 2304w", "/instana-humio-hybrid-systemZ/static/a9386e2666e3b55ac995b1ac82ef56d6/1360d/crio-containers.png 3438w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy",
          "decoding": "async"
        }}></img>{`
    `}</span></h2>
    <h2>{`1-2: Exploring Context Information`}</h2>
    <p>{`The previous steps showed you a fairly traditional approach in monitoring. You look at metrics starting from the infrastructure level. This can still be handy, but in todays complex world there is a number of more interesting ways of looking at metrics. Instana offers you for example to look at the data in various context beyond the infrastructure. For example in which application(s) is this service used and how does it impact them.
`}<strong parentName="p">{`click on the Infrastructure icon`}</strong>{` in the left menu bar.`}</p>
    <p>{`You now return back to the full Infrastructure map view.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "514px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "205.20833333333334%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAApCAYAAAA1bQl+AAAACXBIWXMAABYlAAAWJQFJUiTwAAAFCUlEQVRIx51WWW8bVRS+XuKkWbpEaeLd4/GMZ+zx7mZxVidNnbhN04QqpEDI0pCUFCGKFNqCVCoKVWkLEq/lgYcugCoQYlEFaql4aQniAcFf4Id86J4ZO3ZiJw4Pn+6dO3fOnPOdle0Xw2hRU2hWEmhRkmhWkvS8X03RWtgXULhTDczmCoC5ZJg8Cq3MHQTr8IO1C/raIYK1G898Ne5WA7PY/WiNdiM/9xoyk7Mwe1Ukx6eQGDuFVH6awPfJsSnEcpM4EEqDeRRYfKGKYKzdC093FmfOv43j86uoE8KYWDyHqeXzOD6/gt5Ts/Q8vfIGTq++ifZEhqyoKrDeLcHkDRGHDYGorrZd1M3lqyNgmG7A0I5bUlWg2RcmQYVLViFcFTsJK9OQOaWiKVYDWy9bK+y3Cicv2wJR+DMjOBzvAXMFwRyS/gMO7nkOvneUnHEqDAW40IJgZrYLcHdlMbt2AZNLazikdSKem4Q6NA55IAdfzzCk/mNQBsegjZygM3fnEELZPNpiPURVmYZ1ThFNShLZmVcxsXAOTcEEPF1D9JHryCDsyT7yrCPdD49xxi3hgvnPtwnkHDKvSmbYxMhmgBfAA53DKZfTUM3kBrdMvNlTfWiUY+WcuTaF8A8KXtYjoYpTrE4RzWoKqxevYHhmHvukGPGnZvPEXXBwDGLvKJ2bKmTINoHcKfZ0P07Mr6J/+mXsk2PwdWfJGc70AFxHBoi/QtBXi79yDj1q0cRtHBowGZrsFNRlgc01qPNrlQWWkL+rhjywrf4IXr98FYOn59AgxRAdPUlxxjnUjk7A05WtydyiQG5O7+QMxMwILF4V9mQvOhIZtEW7YE9k0KodgckdhNmrwOzZATz86j0yLFICzKWC+TRYA3GYhAjB7I8WV5ucQJ2UoPdWaQvoLAGLPwLWEu2D772vEP/gIUJXvob30n24Lt6D8517cKzrK4d9/S58l+9DfPcB/Ftx6R4CV79F68k1sObYIOTrj/DdP/9i/fu/oN14hLWHf2LxwQaWvvwDr9z9HQv3N7DwYAPJ2z9DvPYj5I9+gvzhJqRrP0C59SvaTl8Aa0kMQbn9FCvf/I0TX2xAvfUEI3eeYfTOcxz7/DmO3nlGK0f006eQP34M5eYTKDcfFxG88QtCnz3D4Zl1sEYpjoPHV9B4bBHNubM4mF9GU26pIg6OL+NQvhLOonXiHBo7x8BsThHMLsDq9MPsEMDsPpgcwnbYBbrH32+H8Z1LMlqAoOnVg8eaoMHMg9gXJliEWqHB4guD1bv0npLOT6Mj2UtC6wNR2EQN9WKESn0tGbIlUzS89f515F5ahM2vITE2hZ7JF5HOvwDvHrKkJJdVEmRRUlRseW/mxZbnNseeNNQ5DFO1SYsyDgkqmV0YLcwlVaam4tDg1ttnoGsQvw2n0KeEwMQYmqQYcbkX7UrqoYKL1z9BfnYeDWIE8dwpmm+83dkd55gdndIa6USTmiIBBfP2au6mU/iGV+ViIa3eM2pziq8wu1S+tGcvF2cbl6wXSefmKGLaZdqqyCHXcPTMIrVOHndCzwhND45UPxrl+P8IbF8I43PLNLtw03kv5v2Ee/tAOL3jgFndZKO7lZnskHYdMEvP9Z5CTgnp1cYV1NtoyaxYizCeuoX7xCEvP8GBHFUbPn0F+kaJv1oyxeRRqadzakgZcooQJs7a4xkaRZShcRpFePnaTSB/zwsJn9G5pv8Bqv2bPqeKYTQAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "infrastructure menu",
        "title": "infrastructure menu",
        "src": "/instana-humio-hybrid-systemZ/static/ec1709a88fb9b4349412ca125d823dc6/7993d/infrastructure-menu.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/ec1709a88fb9b4349412ca125d823dc6/7fc1e/infrastructure-menu.png 288w", "/instana-humio-hybrid-systemZ/static/ec1709a88fb9b4349412ca125d823dc6/7993d/infrastructure-menu.png 514w"],
        "sizes": "(max-width: 514px) 100vw, 514px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p><strong parentName="p">{`Type k8s-bstern2`}</strong>{` into the search bar`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "57.98611111111111%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAABYlAAAWJQFJUiTwAAABuklEQVQoz5WSTWsTURSG59/oTrGbNM1oMpkZKeajaaJzZyZJk8wMKqarkYjWD5RuWuvCdlOQQsGCuupKXXQjRNQKgssuhKJWdOVfeGRuYjpJxdDFwzkc3vPec+69ilm0MAqXSBkFktmcjKpRGMS/+dnzRUm8ro5ooqjouYtEppnpWZLZPGdSJqcmdU4nhzk5oXFiQjtSH0XJVGpofdLlKuqMTaoo+tioRUEiJ2h3fMKFgETOZqoQ1e2BJh6VrOMxwPXRqxFBDJ+08Nn9tMOb3ddkHJ8LzUBqzVpwRKtk7RZxtBjRITIXDbofP7P1ssu9lfu8//CEvNcmUWqQEZHusGd4whE0x8N0PTRrjp3uOza3X7H+9Bl7+18R8x1uLLYpX75C2moNesYa6lFuN7GuhXKt9a3n7O3/4M6jVX79fMvCyjKTpRpG1Zf6/xr2Vu7ndpOpkkP4YImNF9tcX3zIl4PfdJbWSM666G4gVx9rGMdwfWmcmHFohbc4+P6Nm8uPUUsOZas2fuV/Tau7kbHHdD2gffsu1tV5wjlBXtTlDziW4TAt1Eod02lSafTu+9gTjqK7vYc4Jw5rfwB3Be15g2cNogAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "k8s bstern2",
        "title": "k8s bstern2",
        "src": "/instana-humio-hybrid-systemZ/static/c2b37b142273a1f14fa1f71785d1f193/3cbba/k8s-bstern2.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/c2b37b142273a1f14fa1f71785d1f193/7fc1e/k8s-bstern2.png 288w", "/instana-humio-hybrid-systemZ/static/c2b37b142273a1f14fa1f71785d1f193/a5df1/k8s-bstern2.png 576w", "/instana-humio-hybrid-systemZ/static/c2b37b142273a1f14fa1f71785d1f193/3cbba/k8s-bstern2.png 1152w", "/instana-humio-hybrid-systemZ/static/c2b37b142273a1f14fa1f71785d1f193/0b124/k8s-bstern2.png 1728w", "/instana-humio-hybrid-systemZ/static/c2b37b142273a1f14fa1f71785d1f193/4ea69/k8s-bstern2.png 2304w", "/instana-humio-hybrid-systemZ/static/c2b37b142273a1f14fa1f71785d1f193/d0bec/k8s-bstern2.png 2378w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p><strong parentName="p">{`Click on the k8s-bstern2 zone`}</strong>{` which contains a kubernetes cluster.`}</p>
    <p><strong parentName="p">{`Click on Open Dashboard`}</strong>{`
`}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "55.208333333333336%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAABYlAAAWJQFJUiTwAAAB/ElEQVQoz52Sy2sTURhH5+9xUyvYmubVJjOJSc1D06SZycM8mpiG2pJoFwYjSnGjIjQKggpSsfWFxigtESVKRVHBQhAUxKVCiyJuAurmyJ00NdqNOnD4Xe5377mvkYbcAZz+MLIniEn2YFK8mB0+PbsxK14sTh9mh3dTrRvJsnM3g+4Ag649DNh3sc3spMdgZ+uAskGvnjJbttvoMcj0Gjt9m5E8iXHi+SKxfJFo/gBqroArMobRG8bkU3VEeygQIVMYxxmOY/D8qv2JNDt3lbera7xbXePDl0+0fnzn8u17GEdiOGJZlFgG62gSdXKa5yvPyJaOYtNSuBL7kKMZvS6yg3T6Vo1qq8Wjr595/+0j4qvdb7DDr6JExpC1NOZgnOjkNC+bb8iVZlioVjl+9hx9PhVrKIFdS2NTUzrSoRMVFh885m79oS5aaixTPnVGl8jrQns4wUhuivk7iyQPHubFSpPK3DXUiQL7jxzDOtqWCiQxsd+v0u/X1lPVZZ1VRQqpEknjEMeKjPGq+ZrKpSvMV2vUl5/+LhQDFHEXXYi+zoC2uJ2KlkLWUpRPzhIvlrhRW6LeeLKxsC7snvg3iN1ag3H6/BrnL17g5vUFLKG92NXk/wnFbsVjiSsYTmRxJ7JMlGcI5Yv60f9ZqEs7bfGy4STDybz+i4lX/gm4INjpYqa2nQAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "k8s bstern2 dashboard",
          "title": "k8s bstern2 dashboard",
          "src": "/instana-humio-hybrid-systemZ/static/b9c54bf53e30b34644f4e3d78a509810/3cbba/k8s-bstern2-dashboard.png",
          "srcSet": ["/instana-humio-hybrid-systemZ/static/b9c54bf53e30b34644f4e3d78a509810/7fc1e/k8s-bstern2-dashboard.png 288w", "/instana-humio-hybrid-systemZ/static/b9c54bf53e30b34644f4e3d78a509810/a5df1/k8s-bstern2-dashboard.png 576w", "/instana-humio-hybrid-systemZ/static/b9c54bf53e30b34644f4e3d78a509810/3cbba/k8s-bstern2-dashboard.png 1152w", "/instana-humio-hybrid-systemZ/static/b9c54bf53e30b34644f4e3d78a509810/0b124/k8s-bstern2-dashboard.png 1728w", "/instana-humio-hybrid-systemZ/static/b9c54bf53e30b34644f4e3d78a509810/4ea69/k8s-bstern2-dashboard.png 2304w", "/instana-humio-hybrid-systemZ/static/b9c54bf53e30b34644f4e3d78a509810/5f4f0/k8s-bstern2-dashboard.png 2354w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy",
          "decoding": "async"
        }}></img>{`
    `}</span></p>
    <p>{`You see now an overview of this cluster and the various nodes it contains.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "30.90277777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAGCAYAAADDl76dAAAACXBIWXMAABYlAAAWJQFJUiTwAAAA30lEQVQY04WQS2/DIBCE/f//Wg9JD62iNMdWcSK/eBh22bWnAlTLbg9F+sQiZmYXmuAJcyDsl+oCToIkeoDT71pAnDCHCOYEFkFzvt9wul7x8nrB+f2G09sHnv1UTFn8HznMOo8QCTElNA9n0E0GbTeg7UZ83h9FoKp1yj1yREQLuY7EJbRhlmrU+pRAXDonXbCua+HnGybrQUlKPRgLH6l4dVHoUvVNDtjjI8PMBBcIonWCHJCbtP1YNJEZX88e3eTgA23DZN0WGDmV3fiA0XlMbv5Db9x2N1hfz/ao/QYft9GurnXQSwAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "zone context",
        "title": "zone context",
        "src": "/instana-humio-hybrid-systemZ/static/4e73a4440df8b6a7e60a9e4c9ae1cb27/3cbba/zone-context.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/4e73a4440df8b6a7e60a9e4c9ae1cb27/7fc1e/zone-context.png 288w", "/instana-humio-hybrid-systemZ/static/4e73a4440df8b6a7e60a9e4c9ae1cb27/a5df1/zone-context.png 576w", "/instana-humio-hybrid-systemZ/static/4e73a4440df8b6a7e60a9e4c9ae1cb27/3cbba/zone-context.png 1152w", "/instana-humio-hybrid-systemZ/static/4e73a4440df8b6a7e60a9e4c9ae1cb27/0b124/zone-context.png 1728w", "/instana-humio-hybrid-systemZ/static/4e73a4440df8b6a7e60a9e4c9ae1cb27/4ea69/zone-context.png 2304w", "/instana-humio-hybrid-systemZ/static/4e73a4440df8b6a7e60a9e4c9ae1cb27/596cc/zone-context.png 3240w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`This is due to the fact that this zone is setup to filter the nodes belonging to this Kubernetes cluster. You can now also drill down in this Kubernetes context, by `}<strong parentName="p">{`clicking on the Stack drop down`}</strong>{`. The Kubernetes context shows you information which is relevant from a viewpoint of the operator managing this cluster. He can now see which PODs are running onto it.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "81.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAAACXBIWXMAABYlAAAWJQFJUiTwAAACD0lEQVQ4y42U627TQBCF/f7PhQpKRGijtKHpDxCiSMS5eL33tXcPnLE3LQWhjDTyZm1/e87MOI2PCdYHHLseSluEmODfJPdiGq7K5nxS6I49dG8RU0IuBf+Kq4GP7TcsfmyxfNriZrnBu+UaHz49YLl+xPLus6zvd18x5oI0jJcXuR7GLNe6z2vzcPyOVfuEzfMXrNY7vF/d4+bjBou7LRa3WwHebnboOwXrPFIaMBAQI7Tp4XwQZwQa59F0JiHYgBQHlJKBklHyeLGaAKgh4bnr8NMYnGKEH0eUnOFDEFDOBcZaOaTxMcLNjVGql+w6BWPYoChqal1LKdDGikoGFfM3o21bpJTQuBDB9CEixgTnPZzzsNZJjlRTiiTXqtcY5r2OAnotwMPhgBBCBSYBhhBhnRP5PJkqhzdAQqrCc6ckGfv9XoQIkLPmQhCANga91nJzGAYBVbt5rltVTTcUwDidzlKiF6D30KoX6AR0ooQPsTYVykPyDGd9axB8Unq2zC8iBHjnpNC0LGr1pJaqvQ8C5n0qJLCuGSxRe1avgVNjjJ1qyKyN4TjwQAI5d9Vytc/g84eu/xMYwvQiu+VfJdVUy5OqLLYneP4PkDP5amwu4+OcDG9tCq+EU0A97C+gm9XY2bKMj6FtK2CuaZ2HXoDxBcg6X2o4/YVNU6+tg5YaOvTG4tipq7I9nXH83eVfv0nYVIHE0l4AAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "kub context",
        "title": "kub context",
        "src": "/instana-humio-hybrid-systemZ/static/1a8432fda682ed457996153c11a22308/3cbba/kub-context.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/1a8432fda682ed457996153c11a22308/7fc1e/kub-context.png 288w", "/instana-humio-hybrid-systemZ/static/1a8432fda682ed457996153c11a22308/a5df1/kub-context.png 576w", "/instana-humio-hybrid-systemZ/static/1a8432fda682ed457996153c11a22308/3cbba/kub-context.png 1152w", "/instana-humio-hybrid-systemZ/static/1a8432fda682ed457996153c11a22308/0b124/kub-context.png 1728w", "/instana-humio-hybrid-systemZ/static/1a8432fda682ed457996153c11a22308/b5fb7/kub-context.png 1806w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`From here you can also switch to the Infrastructure context where you could see information on the containers that are running.
Even more interesting from a today viewpoint is that you can select one of the worker nodes and move up to the application context level.
`}<strong parentName="p">{`Click on the first worker node`}</strong></p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "48.611111111111114%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAABYlAAAWJQFJUiTwAAABkklEQVQoz42R627TQBCF/f5vwy+EAImKa1UlCiiAqoKiQto4ie317nqv9uZDu2kbpPZHLX0ae2bnzJ5x5eOIUAONkKjBEuKID/EROf8cqnYvEE2P1oYpJaZ04Knn2YLL7YrlfsXF8jsfzhd8nn1j8eMXX3/+LsyXV1yu1uQ5cZweCCWm03ccS6zOt5fMuivO5nNevv3Ei1dnvH5/wbsvi8Kbj7MyyBqLdR4fj/ZjHBmMwvlQVpLFjPNUUnmcdvC0UxIwTCPrtmUjFXKMuDSRG5x3hBCZpqlgrKWyIeBiLD/l+qbm72bHn9st27anU6YgBodyAWUDO6Fo5IC2odR2nURZT71vUUpRWR9wISAHy77XbFtZxOpGFIS2SOORxtEPjnXdFKEsfrvrWK1rpA1sdg1SSioXIrbsIeCcxxjLYEwhW0gp3Zk/cDgc0HoghFAy+WzbiWNeKYToT4LO+7J0a90DeUDeTW5ImZRQRTAeBa2lE32pZ7v/WY5lWr6y1roU7ptSOgqdYjoOuHu/d5Bv3SvNP+GiAS0ibhiDAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "select worker",
        "title": "select worker",
        "src": "/instana-humio-hybrid-systemZ/static/51aab0b48b60b589f3eff080d7de28cf/3cbba/select-worker.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/51aab0b48b60b589f3eff080d7de28cf/7fc1e/select-worker.png 288w", "/instana-humio-hybrid-systemZ/static/51aab0b48b60b589f3eff080d7de28cf/a5df1/select-worker.png 576w", "/instana-humio-hybrid-systemZ/static/51aab0b48b60b589f3eff080d7de28cf/3cbba/select-worker.png 1152w", "/instana-humio-hybrid-systemZ/static/51aab0b48b60b589f3eff080d7de28cf/0b124/select-worker.png 1728w", "/instana-humio-hybrid-systemZ/static/51aab0b48b60b589f3eff080d7de28cf/e0c97/select-worker.png 1780w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Now back from the stack drop down, `}<strong parentName="p">{`click on application view`}</strong>{` This shows you which applications are running in this context.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "76.04166666666667%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAABYlAAAWJQFJUiTwAAACLElEQVQ4y4VUa2/UMBDM//9DCCGoVBWBqNoPSIiXqAAV7q4Xx4nt9fqZQetcru2hQqSRNrZ3dnbHSec8g2OEcR6T8/AhwfnQ3g0t4BCRcmmIKf8T3b4fsN8p7HY9ejVADRqyNugJjjwsEbyNGAdCP4zwB/InCW+G33jTf8Tl9884u7jGs7O3eHF+iZcXV3j1+grPz99hr0bkXJrS/yrUZLClAZtxwLdfO1x/+IT3X27w9XaDH9s9bjd30KOB54BcCmqtSCnB2Om4lnNGqbXtddoRTEgIIUITQVkLrgURQMX9U+vcEuZ5bhDF5UCutUYShTGhG43FOJlWJcUETx4lZ2BGS3xIYoxtiRJLzkISoZQ6FK3oJuvapswnxATyHjGlhexAtGJqhMuengxCjCilwDnXWk85o7OOoPUI56gteGYw8yNlK7m4Lq3KnpwTsqZ2nND36p5QDjIHDEpBjxNCKsd2H0LULfHcWl1NMtbCOHdw2Thsd1sodQcSg6QAl0fqVkjxUupxnjKiVijGo3mdth6GGT44kA8g8nCcm4pTQmNdM2+N26xrxUQMEwtsqugMEX7qAbfjBPIMRwQXypFwNUbeTwnFlLnOmKzG5BQMDeic97DBY7CmtSCE1mfUWRpYyFp0IFnN4hCOV4iZECMhJ14I5d6xZ3i/OEy8fGI5pWbECpmbXF6JxWVRKOZIXrvoRVp2BOLQ/jgks+TQDkv7f4FPYmbI30pyQkqtwz8Zn4zL4LtN1AAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "application context",
        "title": "application context",
        "src": "/instana-humio-hybrid-systemZ/static/3f058ac026e1720a6f622a5066809709/3cbba/application-context.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/3f058ac026e1720a6f622a5066809709/7fc1e/application-context.png 288w", "/instana-humio-hybrid-systemZ/static/3f058ac026e1720a6f622a5066809709/a5df1/application-context.png 576w", "/instana-humio-hybrid-systemZ/static/3f058ac026e1720a6f622a5066809709/3cbba/application-context.png 1152w", "/instana-humio-hybrid-systemZ/static/3f058ac026e1720a6f622a5066809709/0b124/application-context.png 1728w", "/instana-humio-hybrid-systemZ/static/3f058ac026e1720a6f622a5066809709/80566/application-context.png 1978w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <hr></hr>
    <h2>{`1-3: Exploring the application:`}</h2>
    <p>{`In a modern digital business world you will typically want to start out from the application viewpoint.
`}<strong parentName="p">{`Application Perspectives`}</strong>{` allow you to group together a number of different services and endpoints into dashboard that shows the health and performance of a business application.
In this section, we use the `}<strong parentName="p">{`Application Persective`}</strong>{` for the `}<strong parentName="p">{`Quote of the Day`}</strong>{` application that was defined in this setup.`}</p>
    <p>{`On the left hand navigation, select `}<strong parentName="p">{`“Applications”`}</strong>{`. You will see a screen open up that contains a list of all applications that are defined in the environment.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "39.583333333333336%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAABYlAAAWJQFJUiTwAAABDUlEQVQoz41R7WrDMAzM+7/hGKwLJdmfwmia2Pr0DcluYIONBYRlRzqd7qb5umA/CkQVZg41+3eIKI6joJQKibsqppf5ClZDJQaxQPVHo/4BqgZmAYv0AWqYXi8zKlGiR+gZlqf9BjxqbDALMqUSpvdlRXzuDd4azD2LWmso3CcDDWoO0v4eUUXBoplHTfQF6HRZVnjDYGi5viQbx0aKQpzaVjFsVQYrx50UB8lg2N8S8G1ZoY5TA5K+Xky8HZKAzR07G247J4C747MGIGf+NPQEDIZPbXjoEoA7aZoVTaSOrfL5r4ihsmQu31f+AGu/kGgWhTYx9VE7wzCgsOJeKF2NTR4kyTANEcmzMuMLxIpzBtv+xBoAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "application perspective",
        "title": "application perspective",
        "src": "/instana-humio-hybrid-systemZ/static/53f0baaa65b006091f3b7486d46394b0/3cbba/application-perspective.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/53f0baaa65b006091f3b7486d46394b0/7fc1e/application-perspective.png 288w", "/instana-humio-hybrid-systemZ/static/53f0baaa65b006091f3b7486d46394b0/a5df1/application-perspective.png 576w", "/instana-humio-hybrid-systemZ/static/53f0baaa65b006091f3b7486d46394b0/3cbba/application-perspective.png 1152w", "/instana-humio-hybrid-systemZ/static/53f0baaa65b006091f3b7486d46394b0/0b124/application-perspective.png 1728w", "/instana-humio-hybrid-systemZ/static/53f0baaa65b006091f3b7486d46394b0/4ea69/application-perspective.png 2304w", "/instana-humio-hybrid-systemZ/static/53f0baaa65b006091f3b7486d46394b0/f46cc/application-perspective.png 3448w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p><strong parentName="p">{`Select the Quote of the Day application`}</strong></p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1082px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "123.26388888888889%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAZCAYAAAAxFw7TAAAACXBIWXMAABYlAAAWJQFJUiTwAAACU0lEQVQ4y6VV23LbIBDl/7+pD33oJ3Qyqduk9XSaxIl1QbDAIqTTYZFkK6nstGXmjGEtDuzZC+rDx0/4fPMFt7s77L7d4+b2Kx4enxH7BI69IM/fC1U3GlXT4vlYI8+PVQPd2YXsb6GwMcYRGIZRMI4nDMNwEeql1XisazxUNTQ52UTk0BkjH/jAMNYKLDlcG2rfatweK8HPVhcyS9CdgSEHk+fGCjpTSC9BDWlYnZCGEX2fBLEvATmtZ9s2lDEWu90Od/ff8WO/x+FwEFf/dShmRlVVaJoWuutgiYTwPBBvgdW6BLHMlQjvvVx3HiW6byOYNzjnYS0tBHmd9U5pkH2KOCD0/Grz+Edkgj4lpJRKCk1pVMgmwo4dKiLUJsD4eFUjFxP4LJBZsnzAoqEODhRZTsmn/y+E8FejcWgIL5oQNkoq23PqPLWE2nqZc58kT50PS+0rHQgUg9wwG7MW1xpAf6k5GHY4kkNjGY0NaIkvatj6KDouhTBdYtEwB6X1HtZHdI4FabP4R3EzplMmJIn6sKSauFxZi9YGeI7y51Zryq5m/fKhomFMcJ4ROK41PE6EFPhir8vJn8koRMTJlrtRJlz6YXbZ9XPabJfcUOoNPhaXZ3t6tUeCUpFD3RVXlgb7puEWiwlRSOdv5qpZJXYXfLk+R7gQEXj7HfFccnJev35zRMOc2E+1xWNt8dRYtBRWj9R5UA7aoaEwBaWXpF69KS4yOPVTkaelBLdumKbmsJXkKkfJBQb5sMCFILbT79l89f9sP62Vy7pxFP3eg2vf/ga9Z6eALeStHQAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "qotd select",
        "title": "qotd select",
        "src": "/instana-humio-hybrid-systemZ/static/802549d65d19eb58d9c7d5fdae70f624/c69bd/qotd-select.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/802549d65d19eb58d9c7d5fdae70f624/7fc1e/qotd-select.png 288w", "/instana-humio-hybrid-systemZ/static/802549d65d19eb58d9c7d5fdae70f624/a5df1/qotd-select.png 576w", "/instana-humio-hybrid-systemZ/static/802549d65d19eb58d9c7d5fdae70f624/c69bd/qotd-select.png 1082w"],
        "sizes": "(max-width: 1082px) 100vw, 1082px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`This opens up the dashboard for the application.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "48.958333333333336%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAABYlAAAWJQFJUiTwAAAB3klEQVQoz22S3W7UMBCF88Y8BzdIXMKb9AIk/lSgZbeLULvtFppu/xK63ThxEttjOx+ytyCQsHQ0I8s+M2fOFBfVLecX11xXG27rDVf3W47bjo2xBB9wCeL/C2Mdqu1oW81oLcY5irKpWJ6vOV6VLFclix9rXtc117rPhOmTDwHvHxECIcQMJ8IwGkZjcxTvKYxxwMQ/Jz026aHBe0/IJDtIJhlxblcoxAhTZIq7AsVm22CcEKeJahDuep9lJilKtVjn/iKMmaRRKneV8hgj9eAZnM/FCrzAFCAIs8rw4UbnfBhGmr7HeJ+b/q3BT6C0RsQiEnJn+3eWSjti8BRPTz7x/OyQZ8sDXnz/wpPFK16W3+D+AXtwgJ/NkfkcOTzE7e3hlqf0JtJrg24tunOEUTC9YK1QvLksebcueX91ydsUL0q+1jXxrsLMZozzI9xigRzNMfsfces1owhdP9ANA3ocaVOe1FhHkQz4gwjEKec2DTn5AxhAJ7mATOCcZAOy2zHujHtcr6LRCjV0bHWLm3bzSryd7tG6zw7eauGoNthhyPdtq2gahbG7LZgeZ5zWqlCrLW2pUKcPNCf3/JzdsP18hfaB1niMjxkuTIwS6Poxr1NyP0VjbF6h1HHq8Be6Df5jMIvBZgAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "qotd dashboard",
        "title": "qotd dashboard",
        "src": "/instana-humio-hybrid-systemZ/static/9b1f23944ce28d9398061893e02ec373/3cbba/qotd-dashboard.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/9b1f23944ce28d9398061893e02ec373/7fc1e/qotd-dashboard.png 288w", "/instana-humio-hybrid-systemZ/static/9b1f23944ce28d9398061893e02ec373/a5df1/qotd-dashboard.png 576w", "/instana-humio-hybrid-systemZ/static/9b1f23944ce28d9398061893e02ec373/3cbba/qotd-dashboard.png 1152w", "/instana-humio-hybrid-systemZ/static/9b1f23944ce28d9398061893e02ec373/0b124/qotd-dashboard.png 1728w", "/instana-humio-hybrid-systemZ/static/9b1f23944ce28d9398061893e02ec373/4ea69/qotd-dashboard.png 2304w", "/instana-humio-hybrid-systemZ/static/9b1f23944ce28d9398061893e02ec373/78f3e/qotd-dashboard.png 3320w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`This view will give you immediately a good view of what the state of this application is. You see golden signals like load on the application, latency, calls resulting in an error and the general resource consumption. This allows for a very quick decision if the application is doing OK or if there are some potential issues. We will see that using Instana we can also get a better idea of the topology of this application and what are the dependencies between the various components.`}</p>
    <p>{`At this moment you have no clue what this application is about. `}<strong parentName="p">{`Click on the dependencies tab`}</strong>{` to get some insight in what is going on in this applicaiton.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "47.22222222222222%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAABYlAAAWJQFJUiTwAAABOklEQVQoz21RiW6DMAzl/7+rPzBp647SFiaGUKEcDUec601xSUarWTLEjv38npNkQ4V9nuHlLcU+zfFxyLErSuyaK0hpKG3iP/g2v0jCOM2QpEBKIekXgbrvcGk61G2P5tqhvAn8TBOU0iAiWOdgrYUxd3fOwfjYWs5719qwJ9Ms4azF1jQRYAw3eh+nCVrrGC+LZBC3DroDavZEasMgfOkcn4/ZN9p+4LMvPpwyDDfB8TjPOJ5z3MSI/yzx2gOgWwHTU4am7e5sjdnIc7wGL41I8TA/6DM9QRJxf+ILIsNVumfYrQzDoKBgG/t9SklQWvOjMGBgxWxW+XlRRknPYLyzDajvabv+T7L/CDEydRMYnvOHHW7XESzE8yLx+v4V1TFgdWlQN20sLsoKgxAPjc/yQ96/bHWpI8NfkJ+/OJziDiYAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "qotd dependencies",
        "title": "qotd dependencies",
        "src": "/instana-humio-hybrid-systemZ/static/af12d3d966768fecb8f8f07980ac3856/3cbba/qotd-dependencies.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/af12d3d966768fecb8f8f07980ac3856/7fc1e/qotd-dependencies.png 288w", "/instana-humio-hybrid-systemZ/static/af12d3d966768fecb8f8f07980ac3856/a5df1/qotd-dependencies.png 576w", "/instana-humio-hybrid-systemZ/static/af12d3d966768fecb8f8f07980ac3856/3cbba/qotd-dependencies.png 1152w", "/instana-humio-hybrid-systemZ/static/af12d3d966768fecb8f8f07980ac3856/0b124/qotd-dependencies.png 1728w", "/instana-humio-hybrid-systemZ/static/af12d3d966768fecb8f8f07980ac3856/4ea69/qotd-dependencies.png 2304w", "/instana-humio-hybrid-systemZ/static/af12d3d966768fecb8f8f07980ac3856/8509a/qotd-dependencies.png 3328w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`These topologies are build in a dynamic way based on detection of calls flowing between components. This allows Instana to cope with the high volatility in todays workloads, where the static definition of a topology no longer keeps up.
With this dependency map you can get a good insight in the application components and there relation, even if you were never involved in the internals of this application. In this case we see web frontend service depending on a bunch of other services. If you want to see more detail
about a particular service, you can just hover over it.
For example `}<strong parentName="p">{`hover over the qotd-author`}</strong>{` service.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "53.47222222222222%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAABYlAAAWJQFJUiTwAAABQklEQVQoz52Sz07DMAzG+/4SR248C4cd4MALwAkESOu6teu6JE3z74eSNlvbIQ5YsmwnsfP5swuAEALZXpSwjP/QeW7BJPOL/8qlYESzLlY3R6RS0/kyaY5MDwO7/QHnfIqL+aPse+85tidU3yffGJPUWouf7qPGt8ZYurPAOpfOinWruUAWITWH5sSu2lPXDc65G6QxJ57HosVvQ4nyuHni/eOTmC4NnIXkHJFYd8NbRnvlcD1l4O7+gc3zC8E7urZJRAopOXUdQiqUVLTHI1pr3IQw8njTcoT9tS353laU1Z5t0/G26+gGjxCSXg+E4ClbwWvZooxbDHMxFO9DKhh/03rAGoO0nlJ5pHFpIIMdB2J8QNgxzuiiLdbEZqkOdWptYmpcrjCzkw+rxV4XS6tgLb3WacdGwuc8z74I2V5b/gFsZ2FhC9jGlAAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "qotd author",
        "title": "qotd author",
        "src": "/instana-humio-hybrid-systemZ/static/1b8d56feedf1687da2cd739b80893704/3cbba/qotd-author.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/1b8d56feedf1687da2cd739b80893704/7fc1e/qotd-author.png 288w", "/instana-humio-hybrid-systemZ/static/1b8d56feedf1687da2cd739b80893704/a5df1/qotd-author.png 576w", "/instana-humio-hybrid-systemZ/static/1b8d56feedf1687da2cd739b80893704/3cbba/qotd-author.png 1152w", "/instana-humio-hybrid-systemZ/static/1b8d56feedf1687da2cd739b80893704/a5a5c/qotd-author.png 1244w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`By `}<strong parentName="p">{`clicking on the service`}</strong>{` you get access to more details. You can jump to the dashboard for this specific service, you can analyze the call stack details or you can get a look at the call flow.
Select `}<strong parentName="p">{`Go to flow`}</strong>{`
`}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "736px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "46.52777777777778%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAABYlAAAWJQFJUiTwAAABXUlEQVQoz2WSy07cQBBF/XnZs+fD2GXFJhsWWbBkgxhppAGhIDICKQqPkbFJGLtfdj9OVO2HPKSkK3e1S6frVneRUiKKYkQbi7GWECMxJkiJ9J8YYsyZ0yEv0ghzrsM6hzGWru8JIeC9J4hCIMie7/H9KMDHRD/WTlEs6dPJZfXO867Mhyht+Gha9gFaH4lTR3UJ7T7nRpvclICLJexqveHn9gHrOppW5yLvA13X060u6H5sSHcbuL4ibW9BNRmotc5j8hNQ4q2q+XJ0zNn3c2RHuhT7yliaVpHOv8H9Dcn7wdHYaZ691hkmIyq63o/0yMnXUy5X61xorSOEwYZIALMEGCPT/K2188UUvff8enrhbvvI79cd9Z+/NEpnyzZf1GB/v2+Ii+Ev4wAoz6OsanZvFWX9nq0bY2jbFqVUtqOUntfyT77L9QHw82liTwqcc7OmXL6fJftie3o2/wCGqbnxRcZMAAAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "flow click",
          "title": "flow click",
          "src": "/instana-humio-hybrid-systemZ/static/08ae8db07b798654c9c98ded8a226b69/d2d67/flow-click.png",
          "srcSet": ["/instana-humio-hybrid-systemZ/static/08ae8db07b798654c9c98ded8a226b69/7fc1e/flow-click.png 288w", "/instana-humio-hybrid-systemZ/static/08ae8db07b798654c9c98ded8a226b69/a5df1/flow-click.png 576w", "/instana-humio-hybrid-systemZ/static/08ae8db07b798654c9c98ded8a226b69/d2d67/flow-click.png 736w"],
          "sizes": "(max-width: 736px) 100vw, 736px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy",
          "decoding": "async"
        }}></img>{`
    `}</span></p>
    <p>{`This shows a view where you clearly see which component calls what other component.
`}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "50.69444444444444%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAABYlAAAWJQFJUiTwAAAA/ElEQVQoz5WRy07DMBBF/f+/wpKfQIDUsgC6QVWANiii6SOxY8/DFzkiIamalo50ZI89c+fKNsX+G3m5QbHZIfv8wvJjjXVRIit3eK8tPDGIGCHBMokPhNo6mLcqx3Oe4WG+wN3sBffzVzw+LXC7zHCzWsESQ0XBIhdJgw17QgiEGCNGkXJVRFXoFRhPBFGByPhCYmyJV2Kc97+GImJv7q9gaLgFOFtnTk35TxxXdX1mmAzX9KvdY6cncMQtntOZwjUelXWwrkEg6vvMUKTbiyr2le0b2tw12NYOe+cQmFvB7aHGobZjQUxYvxSURH1AEwKY5bTgsdtzTBn5AS0xEkU4lqHGAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "call flow",
          "title": "call flow",
          "src": "/instana-humio-hybrid-systemZ/static/06866ffbb420a9bac9f57b71d68178fd/3cbba/call-flow.png",
          "srcSet": ["/instana-humio-hybrid-systemZ/static/06866ffbb420a9bac9f57b71d68178fd/7fc1e/call-flow.png 288w", "/instana-humio-hybrid-systemZ/static/06866ffbb420a9bac9f57b71d68178fd/a5df1/call-flow.png 576w", "/instana-humio-hybrid-systemZ/static/06866ffbb420a9bac9f57b71d68178fd/3cbba/call-flow.png 1152w", "/instana-humio-hybrid-systemZ/static/06866ffbb420a9bac9f57b71d68178fd/0b124/call-flow.png 1728w", "/instana-humio-hybrid-systemZ/static/06866ffbb420a9bac9f57b71d68178fd/4ea69/call-flow.png 2304w", "/instana-humio-hybrid-systemZ/static/06866ffbb420a9bac9f57b71d68178fd/7126a/call-flow.png 2846w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy",
          "decoding": "async"
        }}></img>{`
    `}</span></p>
    <p>{`This view can be used to get some insight in the performance of each of the components. Developers can use this to figure out performance bottle necks.
You can for example see a latency report and see the actual call flows. Do this by selecting Latency and clicking on the top icon which activated the call visualisation.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "39.23611111111111%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAABYlAAAWJQFJUiTwAAAA1klEQVQoz6WR4W7CMAyE+/4PtXfY/w3YRtXBCg1Q2jSx/U1pChsVP9B20snKxT6dk+Lptea5bABDVNF/sjAVEsy4RRJuRPvFfDaba1CEKFmy3DD3Zbp7BKmvmA+MpiGgg0e9x2TaIA5Y9GjwY0/wZ471mt5VdE2FSswJL2bXqsrX+wf1Yjmy3e3o+45yvaIq39hWK47tnqF3uPqFw37BqVkiMmTD+Vqp+ihXRhFElC4I/URNCcOZxn3iDhva0/Yn4V/eKkENohgiNtbL7N2Ej5A735c+5Rup+HZootZv3wAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "latency analysis",
        "title": "latency analysis",
        "src": "/instana-humio-hybrid-systemZ/static/5d34b43abf0dcfb443ffe89ca7928378/3cbba/latency-analysis.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/5d34b43abf0dcfb443ffe89ca7928378/7fc1e/latency-analysis.png 288w", "/instana-humio-hybrid-systemZ/static/5d34b43abf0dcfb443ffe89ca7928378/a5df1/latency-analysis.png 576w", "/instana-humio-hybrid-systemZ/static/5d34b43abf0dcfb443ffe89ca7928378/3cbba/latency-analysis.png 1152w", "/instana-humio-hybrid-systemZ/static/5d34b43abf0dcfb443ffe89ca7928378/0b124/latency-analysis.png 1728w", "/instana-humio-hybrid-systemZ/static/5d34b43abf0dcfb443ffe89ca7928378/4ea69/latency-analysis.png 2304w", "/instana-humio-hybrid-systemZ/static/5d34b43abf0dcfb443ffe89ca7928378/f9633/latency-analysis.png 2832w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`In this case we see for example that the qotd-image service is responsible for the bulk of the latency on the qotd-author service.`}</p>
    <hr></hr>
    <h2>{`1-4: Working with Events and Incidents`}</h2>
    <p>{`Now move back to the Qute of the Day application Dashboard.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "48.958333333333336%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAABYlAAAWJQFJUiTwAAAB3klEQVQoz22S3W7UMBCF88Y8BzdIXMKb9AIk/lSgZbeLULvtFppu/xK63ThxEttjOx+ytyCQsHQ0I8s+M2fOFBfVLecX11xXG27rDVf3W47bjo2xBB9wCeL/C2Mdqu1oW81oLcY5irKpWJ6vOV6VLFclix9rXtc117rPhOmTDwHvHxECIcQMJ8IwGkZjcxTvKYxxwMQ/Jz026aHBe0/IJDtIJhlxblcoxAhTZIq7AsVm22CcEKeJahDuep9lJilKtVjn/iKMmaRRKneV8hgj9eAZnM/FCrzAFCAIs8rw4UbnfBhGmr7HeJ+b/q3BT6C0RsQiEnJn+3eWSjti8BRPTz7x/OyQZ8sDXnz/wpPFK16W3+D+AXtwgJ/NkfkcOTzE7e3hlqf0JtJrg24tunOEUTC9YK1QvLksebcueX91ydsUL0q+1jXxrsLMZozzI9xigRzNMfsfces1owhdP9ANA3ocaVOe1FhHkQz4gwjEKec2DTn5AxhAJ7mATOCcZAOy2zHujHtcr6LRCjV0bHWLm3bzSryd7tG6zw7eauGoNthhyPdtq2gahbG7LZgeZ5zWqlCrLW2pUKcPNCf3/JzdsP18hfaB1niMjxkuTIwS6Poxr1NyP0VjbF6h1HHq8Be6Df5jMIvBZgAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "qotd dashboard",
        "title": "qotd dashboard",
        "src": "/instana-humio-hybrid-systemZ/static/9b1f23944ce28d9398061893e02ec373/3cbba/qotd-dashboard.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/9b1f23944ce28d9398061893e02ec373/7fc1e/qotd-dashboard.png 288w", "/instana-humio-hybrid-systemZ/static/9b1f23944ce28d9398061893e02ec373/a5df1/qotd-dashboard.png 576w", "/instana-humio-hybrid-systemZ/static/9b1f23944ce28d9398061893e02ec373/3cbba/qotd-dashboard.png 1152w", "/instana-humio-hybrid-systemZ/static/9b1f23944ce28d9398061893e02ec373/0b124/qotd-dashboard.png 1728w", "/instana-humio-hybrid-systemZ/static/9b1f23944ce28d9398061893e02ec373/4ea69/qotd-dashboard.png 2304w", "/instana-humio-hybrid-systemZ/static/9b1f23944ce28d9398061893e02ec373/78f3e/qotd-dashboard.png 3320w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`What we could already have noticed in the previous steps is that there is a quite large number of erronuous calls being shown on this dashboard.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1080px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "84.02777777777779%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAARCAYAAADdRIy+AAAACXBIWXMAABYlAAAWJQFJUiTwAAACP0lEQVQ4y62U3UsbQRTF9z8WLSi0KIiI4JOiD2JA8h/4ok+2VB/ExxZFH2yS6sYkmmSz3zszuzvzK7MboQZLtXTgMGf24865594ZR6kcIRVS5UilyPOCvCjJi3ou3oKyJBMSoRSOlJIoivGDgDCM+NdhRVlxzsT3abU6fPt+Sat9R1EUhFGMsDsK8a6gWmucTAj8ICSKE9IsI80EcZqSTLm1obbjb1B1yjZ/O4zdwZgKZroutX6XjyovcKx3d66L697T6/UYDB65vb3lR6tFlr0vZSvAyaOIaDzGeun7Pt7EI0kSsjSjfFb/rNrOs3wKjKm+d3LfJ3h6IhGCJE2JoqhqmReBXuOGF4ErhTagKkossGqmL8zYQ49GaOurUmjfr/0VAu15NS8KtFRVZS2MEHXKutR1ydtt9OVlHeT6Gn12VvOrK3SzWfOHB/Tubs3TFH16ipayWpvTrxSTCU4ZhhiLw0PY3sZ4Hnz5jFldxZycwMEB5sMC5vgYc3SEWVyEiwvM+Tnm00dMp4O5uYG1NcpeD6cYDlHNJnJzE7mygtrbQ25toebnUY0GYn0dtbCAbDSQy8uopSXExgZqfx85N4fcbyB3dqp/i8EjThgEjDo/SQcD/Pt7ysmEoN0h6w8QYw+v3aYcDgn6AyK3SzEa4bkuajgi7j4Q9vvE3S6h61LaPrQNqfk/oyqKDWhvGHuwK1huD3oUT7lExVNu31s+vQhmYU+MY3vnufQv8PvzP/EZWHGOvXaEeg35G/gMpOIXYTIUhFWuzUIAAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "qotd erronuous",
          "title": "qotd erronuous",
          "src": "/instana-humio-hybrid-systemZ/static/408b175173b2fe486dad38bb387ff1c8/4d206/qotd-erronuous.png",
          "srcSet": ["/instana-humio-hybrid-systemZ/static/408b175173b2fe486dad38bb387ff1c8/7fc1e/qotd-erronuous.png 288w", "/instana-humio-hybrid-systemZ/static/408b175173b2fe486dad38bb387ff1c8/a5df1/qotd-erronuous.png 576w", "/instana-humio-hybrid-systemZ/static/408b175173b2fe486dad38bb387ff1c8/4d206/qotd-erronuous.png 1080w"],
          "sizes": "(max-width: 1080px) 100vw, 1080px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy",
          "decoding": "async"
        }}></img>{`
    `}</span>{` `}</p>
    <p>{`You can now get a better insight in what is going on by clicking on one of the red bars and then selecting View in Analyze.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "71.875%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAABYlAAAWJQFJUiTwAAACIElEQVQ4y42TzU/cMBDF90/nhASiF6RWHLhS6IFD6bGcQLQHRKlULrRQENBlN7tJnGQdO/7Ir7K9iG7pSrX0Ymtsv7yZeR4Ya2maGaPRmJvbO4SoCaPv+4j/Gd57OmPojGVgrKMUFT9vbrn8fhXXzWxG3SRYa/F9Hy8tQ/ixdQ7dGQat7gikfi7GeY/1Huf7GFddFw/qOC+H0gmDkHJV1+RFwWQyRYiKLMsYjUZR6VP6y8bTnnMebUxKuRaCyWQSSaZ5zng85nE4pKoW67kMidAlws45TJZRlyWybWmaBinlCwX/UrWg0PtUw9AZpTVaa5x1cSNiOMQ7lzqoFK1qUa2irpt5TGM6Ewm9sVgbFFoGgTUQhP/4szN8VeHD+vAQn2XYUiB/DSnqhnxakOc5MljtxxXt+ddkm28X2OtrOmCgnccLAff3sLYG+/tweQkrK/B2h353l/rhgaKZURQlVVVRdAbx6TPy9Rt4fMSvr2NOThJh+Oi7O/TeO9TmJnpri25nB7W6itnbQ25vU348ZHJ6SnF0TH50zPTLOeXBB/KNV3TvD5AbG+iLi0SYjC0QITUpaVsVaxYsY42hEhVWSmRRokSFmc1o8hzbttH4rZQ0dUOwX3gtizUMBY6APpjd9ykemhPmP9d96nCcIb2UaBtjYocW4BxWaey8e7ZV8z2LVerl+TmiQtWlRx0CQbZ9gnPPJM79FX8+l+64yBG4fgNSmzTIldCJYwAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "qotd analyze",
        "title": "qotd analyze",
        "src": "/instana-humio-hybrid-systemZ/static/248354667047c4be9ff9095fa85f8b69/3cbba/qotd-analyze.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/248354667047c4be9ff9095fa85f8b69/7fc1e/qotd-analyze.png 288w", "/instana-humio-hybrid-systemZ/static/248354667047c4be9ff9095fa85f8b69/a5df1/qotd-analyze.png 576w", "/instana-humio-hybrid-systemZ/static/248354667047c4be9ff9095fa85f8b69/3cbba/qotd-analyze.png 1152w", "/instana-humio-hybrid-systemZ/static/248354667047c4be9ff9095fa85f8b69/cc5f9/qotd-analyze.png 1176w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`This shows a filtering of the various calls that cause errors in the context of the quote of the day application in the selected time frame.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "48.611111111111114%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAABYlAAAWJQFJUiTwAAABIklEQVQoz3VSiXKFMAj0/3+179JcQCDbAY9aa53ZCYEIu8A0p4wlFcxLQsoFKWc0IrB0EAv4BuHf4rlUfD4zaiPU1jAxM8YYaI0CLAIRgaqG38z+hcevb6YlJXTVqORVpGvcu9oGvYHd3p1xMNQxgllrDSKMWiuIKFiq2Yrd9vPqP8WmVZ6FzJoXCFVY58BQwRi2wjoGsJ5nv9vaN/mGKZUayZyyjfFXXt8Qdj/sH3b2y56IOAyfrEvem3tIuSLiipTyMdm1/w2lVE9IUZmkYyk1HnoRs8uEx0CpFbkUiBpKoxjCvGQ0FjRiEPOa0AfCTHi9X7GTh8QTvMDz9cbX44lMHdnZkeDxfEdi32Hf0cllxg+qwPC2r9++Y3ewM7Z93M9v54kR6TGylDUAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "qotd analysis",
        "title": "qotd analysis",
        "src": "/instana-humio-hybrid-systemZ/static/bf63abd309c01a8a0c903cf5a2928028/3cbba/qotd-analysis.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/bf63abd309c01a8a0c903cf5a2928028/7fc1e/qotd-analysis.png 288w", "/instana-humio-hybrid-systemZ/static/bf63abd309c01a8a0c903cf5a2928028/a5df1/qotd-analysis.png 576w", "/instana-humio-hybrid-systemZ/static/bf63abd309c01a8a0c903cf5a2928028/3cbba/qotd-analysis.png 1152w", "/instana-humio-hybrid-systemZ/static/bf63abd309c01a8a0c903cf5a2928028/0b124/qotd-analysis.png 1728w", "/instana-humio-hybrid-systemZ/static/bf63abd309c01a8a0c903cf5a2928028/4ea69/qotd-analysis.png 2304w", "/instana-humio-hybrid-systemZ/static/bf63abd309c01a8a0c903cf5a2928028/3dd8f/qotd-analysis.png 3292w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`The drill down allows me now to perform a root cause analysis. `}<strong parentName="p">{`Click on the QM1 service`}</strong>{` You will notice that this shows some detail on the underlying behaviour.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "23.61111111111111%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAFCAYAAABFA8wzAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAwUlEQVQY022OyW7DMAxE9f//2EPXuM1iyVpIirQnEO3mkFbAgwacwZDh7WvCeV6QKiMW+kOqhDk3vLx+4v30g1smTNeEuTBOl4iP6ez+9zV6T0i5IjdG5Y7K8kR3rzTGUhpyJWTqWI58IcHllhBzRTr8YKogUQ90NQAbtm1naDXDuq54vGP++xORY2ZOYGLkJoiF0bh7wSgeqJovk66P2TOlNuRSwdKdoF3BXdFkv3BcYwdDj1KzXf+HiIBZPDeOuQM4B4XEBb1m2QAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "qm1",
        "title": "qm1",
        "src": "/instana-humio-hybrid-systemZ/static/984e9894bb8f6c4c09d9423339667c77/3cbba/qm1.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/984e9894bb8f6c4c09d9423339667c77/7fc1e/qm1.png 288w", "/instana-humio-hybrid-systemZ/static/984e9894bb8f6c4c09d9423339667c77/a5df1/qm1.png 576w", "/instana-humio-hybrid-systemZ/static/984e9894bb8f6c4c09d9423339667c77/3cbba/qm1.png 1152w", "/instana-humio-hybrid-systemZ/static/984e9894bb8f6c4c09d9423339667c77/0b124/qm1.png 1728w", "/instana-humio-hybrid-systemZ/static/984e9894bb8f6c4c09d9423339667c77/4ea69/qm1.png 2304w", "/instana-humio-hybrid-systemZ/static/984e9894bb8f6c4c09d9423339667c77/aab00/qm1.png 2758w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Notice that this corresponds to some PUT calls towards an MQ instance. If you `}<strong parentName="p">{`click on the PUT call`}</strong>{` you get a view of the detailed stack trace of this call`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "48.611111111111114%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAABYlAAAWJQFJUiTwAAABt0lEQVQoz12SS4sUQRCE+///Fg+CB1FB2KvgyqILq4KHdZzZcXq6p+uV9exPK3v0sA1BFJVdkVlRMXhJuBDpHFMhxM5ZkXIl5XLl5yhITBjrsM7r/0Eiw2laMF4wLjCeJ+bLooWOXOoGFX2Ga62v+yD/9oefh9+Ms2GaF6bFMBvHxW6YjVUs1mODYH3Q5osxyHzBOocxFhcskqIOM+x+HXTTWsfivB5yEnFB8J0l4mNSBOWsB72xm7gXQozUVjmNI8M4zfggLIshiFBrIwXRa/b9Uis+BGprOOdpUbDW4vt01qtVURKtFM7nM8Nu/6TGGmsVtWSgwVppNbOuhdq5ZiYXuNl5RuNJ3hNCVLEYN8GxT/h0PP0X9D5wXoSzq4QCuUIqkCq4uDKFxuNSkFz0ZSVlzJVLbertcBonFYop4Uzg4zfLzd2FN1/ueff9ltcPH3j79Zb7g/BwhKNpeosuaF3g0v13QWPXYzQ87vbqX0qZtq7ot2Z+PL3n8/EVn/YvuDu8ZF39VqORctYBukD3vFwjJDEy9A49c73YH6F37t3WtlnJunEPs1wDL9fw51JUsHN/PPkb7D+U0APbsdyIjgAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "put call",
        "title": "put call",
        "src": "/instana-humio-hybrid-systemZ/static/3940e5008ca8a484fb24fa41bf9ec363/3cbba/put-call.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/3940e5008ca8a484fb24fa41bf9ec363/7fc1e/put-call.png 288w", "/instana-humio-hybrid-systemZ/static/3940e5008ca8a484fb24fa41bf9ec363/a5df1/put-call.png 576w", "/instana-humio-hybrid-systemZ/static/3940e5008ca8a484fb24fa41bf9ec363/3cbba/put-call.png 1152w", "/instana-humio-hybrid-systemZ/static/3940e5008ca8a484fb24fa41bf9ec363/0b124/put-call.png 1728w", "/instana-humio-hybrid-systemZ/static/3940e5008ca8a484fb24fa41bf9ec363/4ea69/put-call.png 2304w", "/instana-humio-hybrid-systemZ/static/3940e5008ca8a484fb24fa41bf9ec363/707dd/put-call.png 3296w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p><strong parentName="p">{`Scroll down on this screen to see a full detailed stack trace`}</strong></p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "64.2361111111111%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAABYlAAAWJQFJUiTwAAAB7UlEQVQ4y5WTyW4bMQyG/f733vsCvfc5CjS5pIgdx0u8zIwWaqGWr5hxmkNaH0rgEyGI+kVS0sqJkGKktkat77Qbpd6hVLIqOSspK983wtdHx6vNrMQ5RJX/s4bmSNFEioFvv4QvP4WNyay2k0GfnvAiuJCJ2mitQe+cXWM7dl7Gzt40Dh90jhaOtnN0EH2AGqE1VlcJ7PYHJutxErChELUuefjcGXzBx0rU/k/C4htZC1oqq1QrZ1UmYxiMZfKJmHQppdSOdWEpb7He5+EOLL1dzZdArThruQyGYZow1mEuJ0JMSAhoKbdtvdPe6Z/4ELS9c3h+Rl9emGLCeUF8ZJRKyJVcOiffMVZo8+Hvid4VnFd33vM6DJxHx9swcDI7Ji/4qCStpFKx3pDy3IaM1kRttz63z4K9NRKwOR7xmy3jcjETV39FUibmOdPEGA4MYf/hfZrQXP7OcH7As+0uF8btltEHjHgG/4akSNaGi8J6eOBgH9nbR3b2gavb453cFxxrZW0M03ng4ib2045J5rLnZyNsx2deF9bszRobrojEfwimQpMMqcFpIPx44DKMHC47/OQIJlIlE22k+Dm20qRBrPSoy94WlB50acFKk1JiRmdCJksk+BtZEkkSJSoa08ItNi2xM/P8D/Pf/g3WJvJKEF4xvQAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "stack trace",
        "title": "stack trace",
        "src": "/instana-humio-hybrid-systemZ/static/9f0724438a5398679f0a23912592c936/3cbba/stack-trace.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/9f0724438a5398679f0a23912592c936/7fc1e/stack-trace.png 288w", "/instana-humio-hybrid-systemZ/static/9f0724438a5398679f0a23912592c936/a5df1/stack-trace.png 576w", "/instana-humio-hybrid-systemZ/static/9f0724438a5398679f0a23912592c936/3cbba/stack-trace.png 1152w", "/instana-humio-hybrid-systemZ/static/9f0724438a5398679f0a23912592c936/778d8/stack-trace.png 1668w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Selecting the bottom of the stack trace (erronuous put on the queue manager) you will see the actual error message.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "41.66666666666667%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAABYlAAAWJQFJUiTwAAABXUlEQVQoz02S3Y5dIQiF9/u/RZ+pSdOrJm16Meec0b1VRMCf1eCeTktCQMUvsPQohdDHwFoL033OO6619/xsmOBHbPjynfAigUrDVQhnYVzUwKK77koJR4wRfJ5odoOkA6+yEGjh5IVY7/hOA6kKmiiEGZQLUmEUYjQWzD5QHJjVEAohXAXEAlNDqYI15931/Netm6htYKsMFYOJQkWxHHglHKwGjuceIRcCVQZrR9O+Ic5ZH0DP1QxNBKVWWB/IpUKt77wQ4SBVvD2eOK+MkANK0z1+4YbeDWOOT6CbXyIinClDrOM9XltD7QOqhsOLYiW83h5IrSDxBbGJJ/3Er/QVv9M35Jowbx5Syh8d3vr5RO7egIMPn13HxPUMeL0eCCWisSHmgJCfSBQgjbfoTv0LZG7/SXG7meGwZhitY5wZOZ7wb2RV0dm977PebK89dyA3+dTNoz+UR/8BfwAnXW4FMLOX6wAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "stack trace error",
        "title": "stack trace error",
        "src": "/instana-humio-hybrid-systemZ/static/95e9e8bfbef94f487dfd99ff6e3f20ec/3cbba/stack-trace-error.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/95e9e8bfbef94f487dfd99ff6e3f20ec/7fc1e/stack-trace-error.png 288w", "/instana-humio-hybrid-systemZ/static/95e9e8bfbef94f487dfd99ff6e3f20ec/a5df1/stack-trace-error.png 576w", "/instana-humio-hybrid-systemZ/static/95e9e8bfbef94f487dfd99ff6e3f20ec/3cbba/stack-trace-error.png 1152w", "/instana-humio-hybrid-systemZ/static/95e9e8bfbef94f487dfd99ff6e3f20ec/0b124/stack-trace-error.png 1728w", "/instana-humio-hybrid-systemZ/static/95e9e8bfbef94f487dfd99ff6e3f20ec/4ea69/stack-trace-error.png 2304w", "/instana-humio-hybrid-systemZ/static/95e9e8bfbef94f487dfd99ff6e3f20ec/a2eec/stack-trace-error.png 2662w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Looking at the detail of the message we note that there is an actual MQ error message which indicates that this queue is full.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "826px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "26.38888888888889%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAFCAYAAABFA8wzAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAwElEQVQY021QWw7CMAzb/Q+JBIzR0W6lb9aXUbMxhsSH5TiJXDddyhnnaw/rAlLKWGIixI3Zg6Mf7ghLRDzO04fz3i+lomuGl/4G6wNSLli2hZjKtvjVZLbX+eeB3bDUiqe2GBjDQ0zgkwQXM0YuSItZUsqRT5DKYJIKjAvigY2Q1uMkFWbngVrR5VJg/QvK2A0O2jg8taHaWA+pNOm2t2oD4wKUtvBhgX9FAiVshi16++4/HGefex37a2+9eTN8A8kNhGKwovj3AAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "error detail",
        "title": "error detail",
        "src": "/instana-humio-hybrid-systemZ/static/69995f5d6ab6e1c0cf8bd92efa1d2110/de0dc/error-detail.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/69995f5d6ab6e1c0cf8bd92efa1d2110/7fc1e/error-detail.png 288w", "/instana-humio-hybrid-systemZ/static/69995f5d6ab6e1c0cf8bd92efa1d2110/a5df1/error-detail.png 576w", "/instana-humio-hybrid-systemZ/static/69995f5d6ab6e1c0cf8bd92efa1d2110/de0dc/error-detail.png 826w"],
        "sizes": "(max-width: 826px) 100vw, 826px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`In this way we quite drilled down to the root cause of this problem, which is nice, but Instana will help you even more. If we take a good look at the menu bar on the left of the screen we notice a red indicator on the events icon.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "122px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "113.11475409836065%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAXCAYAAAALHW+jAAAACXBIWXMAABYlAAAWJQFJUiTwAAADtUlEQVQ4y62V72+TVRTHb3/FFdgGSLu2T5+nfdqufdr9ZGNTOjO60rkgwx/JYkccQxmyqSDCFGZcNqcsMJEp0SzKZnhjMO6NJi76QvwRoyaamCiJ/wAJGv8AX0CyfMy97ca6LfACX5zc2+fe++m553zPucIRSnKv5gynEFUmo1PTiDUbDKs4T+EIS6spjPKgssK63ZB7LGXrAu2GhV3Owyk1t2lRRFUI4dWx+UI4tBjCsBBGASptCboGaF/yKpzC5o9g1xO4m3NUPtzP1u5BKjr7EQ0deCNJtEgBKoowCS0BLsNCSWx+k43pR9GGLqA9fxHfgTG8vSNUPX2Gqf0D/NNu8W/GYrbZojxsLUPXuXIKWyDClr1HMIbnKM/kVeycWgThDZGPR6Ajxs2MxY9pC3IWbzYmEXoSV8jCVQJU1zSpzPWhn7iEy2pFVBkFr/UEQkvwYVMCOlN83JLgVEMcdif5+YFqhJ5Q+0qA9mA1LqsF48Ql3E27Eb4wrkgdwh8lls7S9+oEZ3fthEyMX9qSXG6xIBvn032PIOI7cOpxXGbNbaDwhdi6bwjvU6Mqq0omxUQNnR7j9YszHBse4bPtUeUluRR/tJqkD43j7jyIXTpg1t4GSnn4D01SvutJdXVXpLDY2t3DWzOzXP3hJyZn5mjKdZM1TfJ1tWwOhHF3PYOvb6xwZqWHdiOBNjTNhpYu7IGoiktFsokXXpvgy2++55PPF1j4+lsGR8YR4RqVCOE3KW97jMCzU9gC0VVAPUFg8AIbWvfgCMYQvijZ/EFmr8yzuLjIr79f4+atW8xdmSfb04fwRXBqUTY99AT+gXNrgVIuVf0TbJbi3aYRbM0wcvZtFq5+x/Ubf/HbtT+5fuNv5r/4itHz7+Jp2InwBFXcPb0j2FbHUGa1MneAwOFzCI+BtzHN0dE3OD52Ro0vFseXxic5/MooFclmRCCK9tw7lLf3FGNYWxpDh1lD8Nj7VGT3I+4PIHQLp1mjKmDZ5LV0S61v2TNAYGgaeVaqoVTYqkqiuHd0Ybx8mU1tjythy+zL+KqmoSfUHvm9oqMXY/gj7qtvx6bFVJWtreVitWx8cC/GyVk8+dOUNWZwRuoLbStar0Qvtaof/wB3U079wVJnWr/bhAv1LEvPkz9F8Oh7Sk6BI+fVKH9v6zmJs3p7CWzdBquuVYTKUpSJkl6VNXYofZY1ZHCYdeq7XY+XwO7YsVf2RRU3Laa8lqNKXrFzr4Td9QlYvVk9BXdcv9ub8r8/UvcI/A+6jNr4kSXDHwAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "event indicator",
        "title": "event indicator",
        "src": "/instana-humio-hybrid-systemZ/static/e7db6540a01a5a45b89b024a4021c438/0eeb3/event-indicator.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/e7db6540a01a5a45b89b024a4021c438/0eeb3/event-indicator.png 122w"],
        "sizes": "(max-width: 122px) 100vw, 122px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Click on the Events which opens the Event dashboard page`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "47.56944444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAABYlAAAWJQFJUiTwAAABo0lEQVQoz5WSO28UQRCE93cCIfiQEBJE/BwTEOHgzuKRgpEsObFFghDSnUBYgHmYu9uZnZ7nfqh7bXEJAUGpZ6qru2t6t1uvN6QUyTn/H0ohpUQYBvrtBgmBKIFuHQpDg6gYIRSQMpIaJP6NvJMXIIzTudsuj4nL18jqiLh6g5yfIpefkW/vkeUrRLnV0V+o9tMJQTUfjwlvnyCn+8jZY+Rsn86/fESa30bmM+JihhzeQ54/ZHh2H7/Ywy328IuZxUHj/A7+8C7uxQPj+4NbuIObhv7pDboQgu0kpkSy/SRyirbXtLMviRGRaGfTR5lytZGKolrsckyklNn2jt55ahtpI5Ta7C4xMQLRNJ5cquV9EIYgNNOPxvc+0EURm9z3jiBCKZVaq31B/QOUq63ZC3Soxlob3g8G07fGxY9fXK43dCrQ6X4IBImUWq0g54Lzg+W0IF1plNd8CGKYhuWptlS6dLUbna6CyeHU4Lc5jPasa4fK7zrUnD79y8VPts7TlRiJEtlse5zzk8M2OVROG1w3tHue7upeofvThu8+rDj/+p0/Q8L1OVlSbjUAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "event dashboard",
        "title": "event dashboard",
        "src": "/instana-humio-hybrid-systemZ/static/5043e1cee3fe5ecd7fe2c7ab092cefdf/3cbba/event-dashboard.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/5043e1cee3fe5ecd7fe2c7ab092cefdf/7fc1e/event-dashboard.png 288w", "/instana-humio-hybrid-systemZ/static/5043e1cee3fe5ecd7fe2c7ab092cefdf/a5df1/event-dashboard.png 576w", "/instana-humio-hybrid-systemZ/static/5043e1cee3fe5ecd7fe2c7ab092cefdf/3cbba/event-dashboard.png 1152w", "/instana-humio-hybrid-systemZ/static/5043e1cee3fe5ecd7fe2c7ab092cefdf/0b124/event-dashboard.png 1728w", "/instana-humio-hybrid-systemZ/static/5043e1cee3fe5ecd7fe2c7ab092cefdf/4ea69/event-dashboard.png 2304w", "/instana-humio-hybrid-systemZ/static/5043e1cee3fe5ecd7fe2c7ab092cefdf/24a56/event-dashboard.png 3412w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`You notice the MQ queue full event. If you click on that one you immediately see the details of the problem that is at the basis of our previously detected errounous call rate.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "49.30555555555556%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAABYlAAAWJQFJUiTwAAABe0lEQVQoz42S2YobMRBF+/9/Lp6HCYFAmPEy2O69tUslnUHqxAmYkDwcrlpLV+ledcu64UMkJiEkafq/hJiw1rFuCuc9zgc64wMuRmJMBB8wxmKdJ4mQkuz6J+lZ61nvAyKZblMa6z2SM1ZrxmF8VGwduL1ypY5DiLvGXevtfAjth8Y6OqcNwzhhjMGFyGYsUiCIkAFTD8XY7KjjVAo2hLbHx4SU0tZSLiht6Fal6ce5bXbOs1yvqP5ONrpRvGtkZ580u19qIXj0stD108LlNrAaj7MOOb+TT2/k8xvy/gP5+oK8Hv5JeT2gvn+jqyHM89o8q1eo/imlCLk0X3NK5BT/QtqJEbKgto3OKM00r81UF4WtH1jOJ8Zhwq8r2RrEPPN7XjeKtWzTVDs0DNP8SKxWMdvWKpeUkBhINYQYWyfyE19fRoyUGl5KkDNaKboatdJ2fxpS8Lcr98MXbscT6ryjL2fMx+XxPZ+OjMcTsb8jQ08aevI4sN1ufAKP3QWnc+ScpwAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "qfull error",
        "title": "qfull error",
        "src": "/instana-humio-hybrid-systemZ/static/ff5babc0c18ae204489f49c9b59d0af0/3cbba/qfull-error.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/ff5babc0c18ae204489f49c9b59d0af0/7fc1e/qfull-error.png 288w", "/instana-humio-hybrid-systemZ/static/ff5babc0c18ae204489f49c9b59d0af0/a5df1/qfull-error.png 576w", "/instana-humio-hybrid-systemZ/static/ff5babc0c18ae204489f49c9b59d0af0/3cbba/qfull-error.png 1152w", "/instana-humio-hybrid-systemZ/static/ff5babc0c18ae204489f49c9b59d0af0/0b124/qfull-error.png 1728w", "/instana-humio-hybrid-systemZ/static/ff5babc0c18ae204489f49c9b59d0af0/4ea69/qfull-error.png 2304w", "/instana-humio-hybrid-systemZ/static/ff5babc0c18ae204489f49c9b59d0af0/5d4f9/qfull-error.png 3250w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <h2>{`1-5: Summary`}</h2>
    <p>{`In this exercise you have explored some of the key capabilities within Instana. You explored kubernetes monitoring. You defined an Application Perspective. And you
explored the application monitoring details.`}</p>
    <p>{`To continue the mainframe portion of the lab, select the lab exercises in the upper left corner.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      